<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

/* ============================================================================= */
/* Call For Price popup */
/* ============================================================================= */
(function () {
    function openCfpPopup(trigger) {
        var productTitle = trigger.getAttribute('data-cfp-product-title') || '';
        var popup = document.querySelector('[data-cfp-popup]');
        if (!popup) return;

        var nameEl = popup.querySelector('[data-cfp-product-name]');
        if (nameEl) {
            nameEl.textContent = productTitle;
        }

        var waLink = popup.querySelector('[data-cfp-whatsapp-link]');
        if (waLink) {
            var baseHref = waLink.getAttribute('href').split('?')[0];
            var message = productTitle
                ? 'Hi, I would like to get a price for: ' + productTitle
                : 'Hi, I would like to get a price for this product.';
            waLink.setAttribute('href', baseHref + '?text=' + encodeURIComponent(message));
        }

        document.body.classList.add('cfp-popup-show');
    }

    function closeCfpPopup() {
        document.body.classList.remove('cfp-popup-show');
    }

    document.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-open-cfp-popup]');
        if (trigger) {
            event.preventDefault();
            event.stopPropagation();
            openCfpPopup(trigger);
            return;
        }

        var closeBtn = event.target.closest('[data-close-cfp-popup]');
        if (closeBtn) {
            event.preventDefault();
            event.stopPropagation();
            closeCfpPopup();
            return;
        }

        if (document.body.classList.contains('cfp-popup-show')) {
            var withinPopup = event.target.closest('[data-cfp-popup]');
            var withinTrigger = event.target.closest('[data-open-cfp-popup]');
            if (!withinPopup && !withinTrigger) {
                closeCfpPopup();
            }
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && document.body.classList.contains('cfp-popup-show')) {
            closeCfpPopup();
        }
    });
})();
/* ============================================================================= */
/* Call For Price - Button Injection (tag-based, client-side) */
/* ============================================================================= */
(function () {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    if (!meta || !meta.handle) return;

    fetch('/products/' + meta.handle + '.js')
        .then(function(r){ return r.json(); })
        .then(function(product) {
            if (!product.tags) return;
            var tags = product.tags.map(function(t){ return t.toLowerCase().trim(); });
            if (tags.indexOf('call-for-price') === -1) return;
            injectCfpButton(product.title || '');
        })
        .catch(function(){});

    function buildCfpBtn(productTitle) {
        var cfpBtn = document.createElement('a');
        cfpBtn.href = '#';
        cfpBtn.className = 'product-form__submit button button--primary button--call-for-price';
        cfpBtn.setAttribute('data-open-cfp-popup', '');
        cfpBtn.setAttribute('data-cfp-product-title', productTitle);
        cfpBtn.innerHTML = '<span>Call For Price</span>';
        return cfpBtn;
    }

    function tryInject(productTitle) {
        var injected = false;

        /* 1. Main Add to Cart button */
        var atcBtn = document.getElementById('product-add-to-cart');
        if (atcBtn) {
            var btnWrapper = atcBtn.closest('.product-form__buttons');
            if (btnWrapper) {
                btnWrapper.innerHTML = '';
                var btn = buildCfpBtn(productTitle);
                btn.id = 'product-call-for-price';
                btnWrapper.appendChild(btn);
                injected = true;
            }
        }

        /* 2. Buy Now / dynamic checkout block */
        var dynamicCheckout = document.querySelector('.productView-groupBottom');
        if (dynamicCheckout) {
            dynamicCheckout.style.display = 'none';
        }

        /* 3. Payment terms (installment widget) */
        var installment = document.querySelector('.installment');
        if (installment) {
            installment.style.display = 'none';
        }

        /* 4. Sticky add to cart bar */
        var stickyAtc = document.querySelector('.halo-sticky-add-to-cart');
        if (stickyAtc) {
            var stickyBtn = stickyAtc.querySelector('[data-btn-addToCart], .button-addToCart, .btn-addToCart');
            if (stickyBtn) {
                var stickyWrapper = stickyBtn.closest('.product-form__buttons') || stickyBtn.parentNode;
                if (stickyWrapper) {
                    stickyWrapper.innerHTML = '';
                    stickyWrapper.appendChild(buildCfpBtn(productTitle));
                }
            }
        }

        /* 5. Any remaining [data-btn-addToCart] buttons not already replaced */
        document.querySelectorAll('[data-btn-addToCart]').forEach(function(btn) {
            var wrapper = btn.closest('.product-form__buttons') || btn.parentNode;
            if (wrapper && !wrapper.querySelector('[data-open-cfp-popup]')) {
                wrapper.innerHTML = '';
                wrapper.appendChild(buildCfpBtn(productTitle));
            }
        });

        return injected;
    }

    function injectCfpButton(productTitle) {
        if (!tryInject(productTitle)) {
            var observer = new MutationObserver(function() {
                if (tryInject(productTitle)) observer.disconnect();
            });
            observer.observe(document.body, { childList: true, subtree: true });
        } else {
            /* Run once more after a short delay to catch late-rendering elements
               like the sticky bar which may initialise after the main form */
            setTimeout(function() { tryInject(productTitle); }, 800);
        }
    }
})();
/* ============================================================================= */
/* Call For Price - Collection Page Injection */
/* ============================================================================= */
(function () {
    /* Only run on collection/search pages, not product pages */
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) return;

    function buildCfpBtn(productTitle, productHandle) {
        var cfpBtn = document.createElement('a');
        cfpBtn.href = '/products/' + productHandle;
        cfpBtn.className = 'product-form__submit button button--primary button--call-for-price';
        cfpBtn.setAttribute('data-open-cfp-popup', '');
        cfpBtn.setAttribute('data-cfp-product-title', productTitle);
        cfpBtn.innerHTML = '<span>Call For Price</span>';
        return cfpBtn;
    }

    function processCard(card, product) {
    /* Find the ATC button */
    var atcBtn = card.querySelector('button[name="add"]');
    if (atcBtn) {
        /* Hide the original button, insert CFP button after it */
        atcBtn.style.display = 'none';
        var cfpBtn = buildCfpBtn(product.title, product.handle);
        atcBtn.parentNode.insertBefore(cfpBtn, atcBtn.nextSibling);
    }

    /* Hide price display */
    var priceEl = card.querySelector('.price');
    if (priceEl) priceEl.style.visibility = 'hidden';

    /* Hide dynamic checkout / buy now if present in card */
    var dynamicCheckout = card.querySelector('.productView-groupBottom');
    if (dynamicCheckout) dynamicCheckout.style.display = 'none';
}

    function fetchAndProcess(handle, card) {
        /* Skip if already processed */
        if (card.getAttribute('data-cfp-processed')) return;
        card.setAttribute('data-cfp-processed', '1');

        fetch('/products/' + handle + '.js')
            .then(function(r) { return r.json(); })
            .then(function(product) {
                if (!product.tags) return;
                var tags = product.tags.map(function(t) { return t.toLowerCase().trim(); });
                if (tags.indexOf('call-for-price') !== -1) {
                    processCard(card, product);
                }
            })
            .catch(function() {});
    }

    function init() {
        /* Find all product cards using confirmed selector */
        document.querySelectorAll('.product-item').forEach(function(card) {
            /* Get handle from quickview button inside the card */
            var handleEl = card.querySelector('[data-product-handle]');
            if (handleEl) {
                fetchAndProcess(handleEl.getAttribute('data-product-handle'), card);
                return;
            }
            /* Fallback: extract from product link */
            var link = card.querySelector('a[href*="/products/"]');
            if (link) {
                var match = link.getAttribute('href').match(/\/products\/([^?#\/]+)/);
                if (match && match[1]) fetchAndProcess(match[1], card);
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    /* Handle infinite scroll / pagination loading new cards */
    var grid = document.querySelector('main');
    if (grid) {
        new MutationObserver(function() {
            setTimeout(init, 300);
        }).observe(grid, { childList: true, subtree: true });
    }
})();
/* =============================================================================
   AutoStyling Klerksdorp — Homepage Finder v3
   Renders into <div id="as-finder-root"></div> on the homepage.

   WHEELS:  Make → Model → Bolt pattern (auto-filled from the car) → Rim size.
            Wheels are matched by bolt pattern (PCD), so a wheel does NOT need
            car-name tags to show up — it only needs its PCD in the title or tags.
   TYRES:   Width / Profile / Rim / Brand, read from the tyre size in the title.
   SUSPENSION: Make / Type / Brand.

   Every field has a "?" explainer. Results appear under the widget.
   ============================================================================= */
(function () {
    'use strict';

    /* -------------------------------------------------------------------------
       CONFIG
    -------------------------------------------------------------------------- */
    var WHATSAPP = '27797278886';
    var PAGE_SIZE = 12;
    var CACHE_MINUTES = 30;

    var SOURCES = {
        wheels: ['finder-wheels', 'wheels'],
        tyres: ['finder-tyres', 'tyres'],
        suspension: ['finder-suspension', 'suspension']
    };

    /* -------------------------------------------------------------------------
       FITMENT TABLE — factory bolt patterns for SA-market cars.
       Format: [ 'Model label', 'PCD' ]. PCDs are written the way the finder
       stores them: 114.3 → 114, 139.7 → 139.
       To add a car, add a line. To add a make, add a block.
    -------------------------------------------------------------------------- */
    var FITMENT = {
        'Audi': [
            ['A1 (2010+)', '5/100'],
            ['A3 8L (1996–2003)', '5/100'],
            ['A3 / S3 / RS3 (2003+)', '5/112'],
            ['A4 / S4 / RS4', '5/112'],
            ['A5 / S5 / RS5', '5/112'],
            ['A6', '5/112'],
            ['Q3', '5/112'],
            ['Q5', '5/112'],
            ['Q7 (2015+)', '5/112'],
            ['TT 8N (1998–2006)', '5/100'],
            ['TT / TTS / TT RS (2006+)', '5/112']
        ],
        'BMW': [
            ['1 Series E87 / F20 (2004–2019)', '5/120'],
            ['1 Series F40 (2019+)', '5/112'],
            ['2 Series F22 / M2 F87', '5/120'],
            ['2 Series G42 / M2 G87 (2021+)', '5/112'],
            ['3 Series E30 (1982–1994)', '4/100'],
            ['M3 E30', '5/120'],
            ['3 Series E36 / E46 / E90–E93', '5/120'],
            ['3 Series F30 / M3 F80', '5/120'],
            ['3 Series G20 / M3 G80 (2019+)', '5/112'],
            ['4 Series F32 / M4 F82', '5/120'],
            ['4 Series G22 / M4 G82 (2020+)', '5/112'],
            ['5 Series E39 / E60 / F10', '5/120'],
            ['5 Series G30 (2017+)', '5/112'],
            ['X1 E84 (2009–2015)', '5/120'],
            ['X1 F48 (2015+)', '5/112'],
            ['X3 E83 / F25', '5/120'],
            ['X3 G01 / X4 G02 (2017+)', '5/112'],
            ['X5 E53 / E70 / F15', '5/120'],
            ['X5 G05 (2018+)', '5/112']
        ],
        'Chevrolet': [
            ['Spark', '4/100'],
            ['Aveo (2006–2011)', '4/100'],
            ['Aveo (2011+)', '5/105'],
            ['Utility', '4/100'],
            ['Cruze', '5/105']
        ],
        'Ford': [
            ['Bantam (up to 2002)', '4/114'],
            ['Bantam (2002+)', '4/108'],
            ['Fiesta', '4/108'],
            ['Figo', '4/108'],
            ['EcoSport', '4/108'],
            ['Focus (incl. ST / RS)', '5/108'],
            ['Kuga', '5/108'],
            ['Mustang (2015+)', '5/114'],
            ['Ranger (all)', '6/139'],
            ['Everest', '6/139']
        ],
        'GWM / Haval': [
            ['Haval H6', '5/114'],
            ['Haval Jolion', '5/114'],
            ['Steed', '6/139'],
            ['P-Series', '6/139']
        ],
        'Honda': [
            ['Civic (up to 2005)', '4/100'],
            ['Civic (2006+)', '5/114'],
            ['Civic Type R (2015+)', '5/120'],
            ['Ballade', '4/100'],
            ['Jazz / Fit', '4/100'],
            ['BR-V', '4/100'],
            ['CR-V', '5/114']
        ],
        'Hyundai': [
            ['Atos / Getz / i10 / Grand i10', '4/100'],
            ['i20', '4/100'],
            ['Accent', '4/100'],
            ['Venue', '4/100'],
            ['i30 N', '5/114'],
            ['Creta', '5/114'],
            ['Tucson', '5/114'],
            ['Santa Fe', '5/114']
        ],
        'Isuzu': [
            ['D-Max / KB', '6/139'],
            ['MU-X', '6/139']
        ],
        'Jeep': [
            ['Wrangler JK / JL', '5/127'],
            ['Grand Cherokee (2011+)', '5/127']
        ],
        'Jetour': [
            ['T2 (2025+)', '5/108']
        ],
        'Kia': [
            ['Picanto', '4/100'],
            ['Rio', '4/100'],
            ['Sonet', '4/100'],
            ['Seltos', '5/114'],
            ['Sportage', '5/114'],
            ['Sorento', '5/114']
        ],
        'Land Rover': [
            ['Range Rover (2002+)', '5/120'],
            ['Range Rover Sport (2005+)', '5/120'],
            ['Defender (2020+)', '5/120'],
            ['Discovery 5', '5/120'],
            ['Range Rover Evoque', '5/108'],
            ['Discovery Sport', '5/108']
        ],
        'Mahindra': [
            ['Pik-Up', '6/139'],
            ['Scorpio', '6/139']
        ],
        'Mazda': [
            ['Mazda2', '4/100'],
            ['Mazda3', '5/114'],
            ['CX-3 / CX-5', '5/114'],
            ['MX-5 NA / NB', '4/100'],
            ['MX-5 NC', '5/114'],
            ['MX-5 ND (2015+)', '4/100'],
            ['BT-50', '6/139']
        ],
        'Mercedes-Benz': [
            ['A-Class', '5/112'],
            ['C-Class (incl. C63 AMG)', '5/112'],
            ['CLA', '5/112'],
            ['E-Class', '5/112'],
            ['GLA', '5/112'],
            ['GLC', '5/112'],
            ['GLE / ML', '5/112'],
            ['Vito / V-Class', '5/112']
        ],
        'Mitsubishi': [
            ['ASX', '5/114'],
            ['Lancer', '5/114'],
            ['Outlander', '5/114'],
            ['Pajero / Pajero Sport', '6/139'],
            ['Triton', '6/139']
        ],
        'Nissan': [
            ['Almera / Micra / NP200', '4/100'],
            ['Magnite', '4/100'],
            ['Qashqai / X-Trail', '5/114'],
            ['350Z / 370Z', '5/114'],
            ['GT-R', '5/114'],
            ['Navara (2005+)', '6/114'],
            ['NP300 Hardbody', '6/139']
        ],
        'Opel': [
            ['Corsa (up to 2019)', '4/100'],
            ['Corsa (2020+)', '4/108'],
            ['Astra H', '5/110'],
            ['Astra J / K', '5/105']
        ],
        'Porsche': [
            ['911 / Boxster / Cayman', '5/130'],
            ['Cayenne', '5/130'],
            ['Macan', '5/112'],
            ['Taycan', '5/130']
        ],
        'Renault': [
            ['Clio', '4/100'],
            ['Sandero', '4/100'],
            ['Kiger / Triber', '4/100']
        ],
        'Subaru': [
            ['Impreza / WRX (up to 2014)', '5/100'],
            ['WRX STI (2005+)', '5/114'],
            ['WRX (2015+)', '5/114'],
            ['BRZ', '5/100'],
            ['Forester (up to 2018)', '5/100']
        ],
        'Suzuki': [
            ['Swift / Dzire', '4/100'],
            ['Swift Sport', '5/114'],
            ['Baleno', '4/100'],
            ['Celerio', '4/100'],
            ['Ertiga / XL6', '4/100'],
            ['Vitara Brezza', '4/100'],
            ['Jimny', '5/139']
        ],
        'Toyota': [
            ['Tazz / Conquest / old Starlet', '4/100'],
            ['Corolla (up to 2007)', '4/100'],
            ['Corolla / Quest (2007–2019)', '5/100'],
            ['Corolla / Corolla Cross (2019+)', '5/114'],
            ['Yaris / Etios / Agya', '4/100'],
            ['Starlet / Rumion / Urban Cruiser (2020+)', '4/100'],
            ['86 / GR86', '5/100'],
            ['GR Yaris', '5/114'],
            ['Supra A90', '5/112'],
            ['RAV4', '5/114'],
            ['Hilux', '6/139'],
            ['Fortuner', '6/139'],
            ['Land Cruiser', '6/139']
        ],
        'Volkswagen': [
            ['Citi Golf / Golf 1', '4/100'],
            ['Golf 2 / Golf 3', '4/100'],
            ['Golf 3 VR6', '5/100'],
            ['Golf 4 (incl. GTI / R32)', '5/100'],
            ['Golf 5 / 6 / 7 / 8 (incl. GTI / R)', '5/112'],
            ['Jetta 1–3', '4/100'],
            ['Jetta 4', '5/100'],
            ['Jetta 5 / 6', '5/112'],
            ['Polo (up to 2001)', '4/100'],
            ['Polo (2002+) / Polo Vivo', '5/100'],
            ['Caddy bakkie (old)', '4/100'],
            ['Caddy (2004+)', '5/112'],
            ['Scirocco', '5/112'],
            ['Tiguan / T-Roc', '5/112'],
            ['T-Cross', '5/100'],
            ['Amarok', '5/120']
        ]
    };

    /* -------------------------------------------------------------------------
       TAB DEFINITIONS
    -------------------------------------------------------------------------- */
    var TABS = {
        wheels: {
            label: 'Wheels',
            title: 'Find wheels that fit your car',
            sub: 'Pick your car and we\'ll match the bolt pattern for you. Tap <b>?</b> on any field if you\'re not sure what it means.',
            fields: [
                { key: 'make', label: 'Vehicle make', step: 1 },
                { key: 'model', label: 'Model', step: 2 },
                { key: 'pcd', label: 'Bolt pattern (PCD)', step: 3 },
                { key: 'size', label: 'Rim size', step: 4 }
            ]
        },
        tyres: {
            label: 'Tyres',
            title: 'Find tyres by size',
            sub: 'Your tyre size is printed on the sidewall of your current tyre, e.g. <b>225/45 R17</b>. Tap <b>?</b> to see where.',
            fields: [
                { key: 'width', label: 'Width', step: 1 },
                { key: 'profile', label: 'Profile', step: 2 },
                { key: 'rim', label: 'Rim size', step: 3 },
                { key: 'brand', label: 'Brand', step: 4 }
            ]
        },
        suspension: {
            label: 'Suspension',
            title: 'Find suspension for your car',
            sub: 'Lower it, lift it, or put it on air. Tap <b>?</b> to compare the options.',
            fields: [
                { key: 'make', label: 'Vehicle make', step: 1 },
                { key: 'type', label: 'Type', step: 2 },
                { key: 'brand', label: 'Brand', step: 3 }
            ]
        }
    };

    /* Vehicle make words for SUSPENSION (matched in titles/tags) */
    var MAKES_TEXT = {
        'Audi': ['audi'], 'BMW': ['bmw', 'e30', 'e36', 'e46', 'e90', 'e92', 'f30', 'm3', 'm4'],
        'Ford': ['ford', 'mustang', 'ranger', 'fiesta', 'focus', 'bantam'], 'Honda': ['honda', 'civic', 'ballade', 'jazz'],
        'Hyundai': ['hyundai', 'i10', 'i20', 'getz'], 'Isuzu': ['isuzu', 'dmax', 'd max'], 'Jeep': ['jeep', 'wrangler'],
        'Kia': ['kia', 'picanto'], 'Mazda': ['mazda', 'mx5', 'mx 5'], 'Mercedes-Benz': ['mercedes', 'benz', 'amg'],
        'Mitsubishi': ['mitsubishi', 'pajero', 'triton'], 'Nissan': ['nissan', 'navara', 'np200', 'np300'],
        'Opel': ['opel', 'corsa', 'astra'], 'Subaru': ['subaru', 'wrx', 'impreza'], 'Suzuki': ['suzuki', 'swift', 'jimny'],
        'Toyota': ['toyota', 'corolla', 'hilux', 'fortuner', 'tazz', 'conquest', 'yaris', 'supra'],
        'Volkswagen': ['vw', 'volkswagen', 'golf', 'polo', 'gti', 'jetta', 'caddy', 'citi', 'scirocco', 'amarok']
    };

    var TYRE_BRANDS = ['Annaite', 'Atturo', 'BF Goodrich', 'Bridgestone', 'Continental', 'Dunlop', 'Falken', 'Firestone',
        'Fullrun', 'General', 'Goodyear', 'Haida', 'Hankook', 'Kumho', 'Landsail', 'Lexani', 'Maxxis', 'Michelin',
        'Nexen', 'Nitto', 'Pirelli', 'Powertrac', 'Radar', 'Roadcruza', 'Sailun', 'Toyo', 'Triangle', 'Vitour',
        'Winrun', 'Yokohama', 'Zeetex'];
    var TYRE_BRAND_ALIASES = { 'BF Goodrich': ['bf goodrich', 'bfgoodrich', 'bfg'] };

    var SUSP_TYPES = [
        ['Coilovers', ['coilover', 'coilovers', 'coil over', 'coil overs']],
        ['Air Suspension', ['air suspension', 'air ride', 'airride', 'air bag', 'air bags', 'airbag', 'airbags', 'air management']],
        ['Lowering Springs', ['lowering spring', 'lowering springs', 'springs', 'spring']],
        ['Lift Kit', ['lift kit', 'lift kits', 'lift']],
        ['Shocks', ['shock', 'shocks', 'shock absorber', 'shock absorbers', 'damper', 'dampers']],
        ['Drop Links', ['droplink', 'droplinks', 'drop link', 'drop links']],
        ['Strut Brace', ['strut brace', 'strut bar', 'strutbrace']],
        ['Camber Kit', ['camber']]
    ];
    var SUSP_BRANDS = {
        'Air Lift': ['air lift', 'airlift'], 'ARC': ['arc'], 'BC Racing': ['bc racing', 'bc'], 'Bilstein': ['bilstein'],
        'D2': ['d2'], 'Eibach': ['eibach'], 'FK': ['fk'], 'Fox': ['fox'], 'H&R': ['h r', 'h&r', 'hr springs'],
        'Ironman': ['ironman', 'iron man'], 'KW': ['kw'], 'Ohlins': ['ohlins'], 'Old Man Emu': ['old man emu', 'ome'],
        'Tebao': ['tebao'], 'Tein': ['tein'], 'Tough Dog': ['tough dog', 'toughdog']
    };

    /* -------------------------------------------------------------------------
       EXPLAINERS (the "?" panels)
    -------------------------------------------------------------------------- */
    var SVG_PCD =
        '<svg viewBox="0 0 120 120" class="asf-diagram" aria-hidden="true">' +
        '<circle cx="60" cy="60" r="54" fill="none" stroke="currentColor" stroke-width="3"/>' +
        '<circle cx="60" cy="60" r="8" fill="none" stroke="currentColor" stroke-width="2"/>' +
        '<circle cx="60" cy="60" r="30" fill="none" stroke="#e8b84b" stroke-width="1.5" stroke-dasharray="4 3"/>' +
        '<g fill="currentColor">' +
        '<circle cx="60" cy="30" r="5"/><circle cx="88.5" cy="50.7" r="5"/><circle cx="77.6" cy="84.3" r="5"/>' +
        '<circle cx="42.4" cy="84.3" r="5"/><circle cx="31.5" cy="50.7" r="5"/></g>' +
        '<line x1="31.5" y1="50.7" x2="88.5" y2="50.7" stroke="#e8b84b" stroke-width="2"/>' +
        '<text x="60" y="45" text-anchor="middle" font-size="10" font-weight="700" fill="#b8892c">112 mm</text>' +
        '</svg>';

    var SVG_RIM =
        '<svg viewBox="0 0 120 120" class="asf-diagram" aria-hidden="true">' +
        '<circle cx="60" cy="60" r="56" fill="none" stroke="currentColor" stroke-width="10" opacity=".85"/>' +
        '<circle cx="60" cy="60" r="44" fill="none" stroke="currentColor" stroke-width="2"/>' +
        '<circle cx="60" cy="60" r="7" fill="none" stroke="currentColor" stroke-width="2"/>' +
        '<line x1="16" y1="60" x2="104" y2="60" stroke="#e8b84b" stroke-width="2"/>' +
        '<polygon points="16,60 23,56 23,64" fill="#e8b84b"/><polygon points="104,60 97,56 97,64" fill="#e8b84b"/>' +
        '<text x="60" y="47" text-anchor="middle" font-size="13" font-weight="700" fill="#b8892c">17″</text>' +
        '</svg>';

    var SVG_TYRE =
        '<svg viewBox="0 0 160 70" class="asf-diagram asf-diagram--wide" aria-hidden="true">' +
        '<rect x="4" y="14" width="152" height="42" rx="8" fill="none" stroke="currentColor" stroke-width="2"/>' +
        '<text x="80" y="42" text-anchor="middle" font-size="18" font-weight="700" fill="currentColor" letter-spacing="1">' +
        '<tspan fill="#b8892c">225</tspan>/<tspan>45</tspan> <tspan fill="#b8892c">R17</tspan></text>' +
        '</svg>';

    var HELP = {
        wheels: {
            make: {
                title: 'Vehicle make & model',
                body: '<p>Pick your car and we\'ll fill in its <b>bolt pattern</b> automatically, so you only see wheels that bolt on.</p>' +
                    '<p>Car not listed? Skip it and choose the bolt pattern yourself, or WhatsApp us your car and we\'ll check.</p>'
            },
            model: { ref: 'make' },
            pcd: {
                title: 'What is PCD (bolt pattern)?',
                svg: SVG_PCD,
                body: '<p><b>PCD</b> means <i>pitch circle diameter</i>: how many wheel bolts your car has, and the size of the circle they sit on.</p>' +
                    '<p><b>5/112</b> = 5 bolts on a 112&nbsp;mm circle. It has to match your car exactly or the wheel won\'t bolt on.</p>' +
                    '<p>Some wheels are <b>multi-PCD</b> (e.g. 4/100 &amp; 4/114) and fit more than one pattern.</p>'
            },
            size: {
                title: 'What is rim size?',
                svg: SVG_RIM,
                body: '<p>The wheel\'s <b>diameter in inches</b>. Find your current size on the tyre: in <b>225/45 R17</b>, <b>R17</b> means a 17″ rim.</p>' +
                    '<p>Going bigger looks great, but needs a lower-profile tyre to keep the overall size the same. We\'ll quote the right tyres with your wheels.</p>'
            }
        },
        tyres: {
            width: {
                title: 'Reading your tyre size',
                svg: SVG_TYRE,
                body: '<p>Look on the side of your tyre for a code like <b>225/45 R17</b>.</p>' +
                    '<p><b>225</b> = width in mm &nbsp;·&nbsp; <b>45</b> = profile (sidewall height as % of width) &nbsp;·&nbsp; <b>R17</b> = fits a 17″ rim.</p>'
            },
            profile: { ref: 'width' },
            rim: { ref: 'width' },
            brand: {
                title: 'Tyre brands',
                body: '<p>Premium brands (Michelin, Pirelli, Continental) give the best grip and wet braking. Budget brands are good value for daily driving. Not sure? WhatsApp us your driving and budget.</p>'
            }
        },
        suspension: {
            make: {
                title: 'Vehicle make',
                body: '<p>Suspension is made for specific cars. Pick your make to see kits listed for it, or WhatsApp us your exact model to confirm.</p>'
            },
            type: {
                title: 'Which suspension type?',
                body: '<p><b>Coilovers</b>: adjustable ride height (and often stiffness). Best for a tuned look and handling.</p>' +
                    '<p><b>Lowering springs</b>: a fixed drop that works with your existing shocks. Most affordable way to lower.</p>' +
                    '<p><b>Air suspension</b>: raise or drop the car at the push of a button.</p>' +
                    '<p><b>Lift kit</b>: raises bakkies and 4x4s for bigger tyres and clearance.</p>'
            },
            brand: {
                title: 'Suspension brands',
                body: '<p>All brands we stock are proven on SA roads. Ask us which suits your car and how low you want to go.</p>'
            }
        }
    };

    var FITMENT_GUIDE =
        '<div class="asf-guide-grid">' +
        '<div><b>Bolt pattern (PCD)</b><span>Number of bolts and the circle they sit on. Must match your car.</span></div>' +
        '<div><b>Rim size</b><span>Wheel diameter in inches. Bigger rims need lower-profile tyres.</span></div>' +
        '<div><b>Offset (ET)</b><span>How far the wheel sits in or out of the arch. Too far out rubs; too far in can hit brakes. Spacers can correct it.</span></div>' +
        '<div><b>Centre bore</b><span>The hole in the middle. If it\'s bigger than your hub, spigot rings centre the wheel. We supply them.</span></div>' +
        '</div>';

    /* -------------------------------------------------------------------------
       HELPERS
    -------------------------------------------------------------------------- */
    function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }
    function wordSoup(title, tags) {
        return ' ' + (title + ' ' + tags.join(' ')).toLowerCase()
            .replace(/&/g, ' ').replace(/[^a-z0-9]+/g, ' ').trim() + ' ';
    }
    function hasWord(soup, phrase) {
        var p = phrase.toLowerCase().replace(/&/g, ' ').replace(/[^a-z0-9]+/g, ' ').trim();
        return p && soup.indexOf(' ' + p + ' ') !== -1;
    }
    function uniq(arr) {
        var seen = {}, out = [];
        arr.forEach(function (v) { if (v && !seen[v]) { seen[v] = 1; out.push(v); } });
        return out;
    }
    function intersects(a, b) {
        for (var i = 0; i < a.length; i++) if (b.indexOf(a[i]) !== -1) return true;
        return false;
    }
    function formatPrice(n) {
        return 'R ' + Number(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    function waLink(text) {
        return 'https://wa.me/' + WHATSAPP + '?text=' + encodeURIComponent(text);
    }
    function modelPcd(make, model) {
        var list = FITMENT[make] || [];
        for (var i = 0; i < list.length; i++) if (list[i][0] === model) return list[i][1];
        return null;
    }
    function makePcds(make) {
        return uniq((FITMENT[make] || []).map(function (m) { return m[1]; }));
    }

    /* -------------------------------------------------------------------------
       SPEC EXTRACTION
    -------------------------------------------------------------------------- */
    function extractPcd(title, tags) {
        var text = title + ' | ' + tags.join(' | ');
        var re = /(^|[^0-9.])([3-8])\s*[x\/×]\s*(\d{2,3})(?:[.,]\d)?(?![0-9])/gi;
        var out = [], m;
        while ((m = re.exec(text)) !== null) {
            var c = parseInt(m[3], 10);
            if (c >= 98 && c <= 170) out.push(m[2] + '/' + c);
        }
        return uniq(out);
    }
    function extractWheelSize(title, tags) {
        var fromTitle = title.match(/^\s*(1[3-9]|2[0-6])\s*(?:”|"|''|″|inch)/i);
        if (fromTitle) return [fromTitle[1]];
        var out = [], m;
        var reTitle = /(^|[^0-9.])(1[3-9]|2[0-6])\s*(?:”|"|''|″|inch|in\b)/gi;
        while ((m = reTitle.exec(title)) !== null) out.push(m[2]);
        tags.forEach(function (t) {
            var mt = t.trim().match(/^(1[3-9]|2[0-6])\s*(?:”|"|''|″|inch|ïnch)/i);
            if (mt) out.push(mt[1]);
        });
        return uniq(out);
    }
    function extractEt(title, tags) {
        var m = (title + ' ' + tags.join(' ')).match(/\bet\s?(-?\d{1,2})\b/i);
        return m ? m[1] : null;
    }
    function extractTyre(title, tags) {
        var res = { width: [], profile: [], rim: [] };
        var m = title.match(/(\d{3})\s*[\/ ]\s*(\d{2})\s*(?:z?r|\/|-|\s)\s*(\d{2})(?![0-9])/i);
        if (m) { res.width.push(m[1]); res.profile.push(m[2]); res.rim.push(m[3]); }
        if (!res.rim.length) {
            tags.forEach(function (t) {
                var mt = t.trim().match(/^(1[3-9]|2[0-6])\s*(?:inchtyres|inch tyres|"|''|”|inch)/i);
                if (mt) res.rim.push(mt[1]);
            });
            var mr = title.match(/\bR\s?(1[3-9]|2[0-6])\b/i);
            if (mr) res.rim.push(mr[1]);
        }
        res.rim = uniq(res.rim);
        return res;
    }
    function extractTyreBrand(soup, vendor) {
        var out = [];
        TYRE_BRANDS.forEach(function (b) {
            var words = TYRE_BRAND_ALIASES[b] || [b];
            if (words.some(function (w) { return hasWord(soup, w); })) out.push(b);
        });
        if (!out.length && vendor && !/auto\s*styling/i.test(vendor)) out.push(vendor);
        return out;
    }
    function extractTextMakes(soup) {
        return Object.keys(MAKES_TEXT).filter(function (mk) {
            return MAKES_TEXT[mk].some(function (w) { return hasWord(soup, w); });
        });
    }
    function extractSuspType(soup) {
        for (var i = 0; i < SUSP_TYPES.length; i++) {
            if (SUSP_TYPES[i][1].some(function (w) { return hasWord(soup, w); })) return [SUSP_TYPES[i][0]];
        }
        return [];
    }
    function extractSuspBrand(soup) {
        return Object.keys(SUSP_BRANDS).filter(function (b) {
            return SUSP_BRANDS[b].some(function (w) { return hasWord(soup, w); });
        });
    }

    function toItem(p, tab) {
        var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
        tags = tags.map(function (t) { return t.trim(); }).filter(Boolean);
        var soup = wordSoup(p.title, tags);
        var prices = (p.variants || []).map(function (v) { return parseFloat(v.price); }).filter(function (n) { return !isNaN(n); });
        var item = {
            title: p.title,
            handle: p.handle,
            img: (p.images && p.images[0] && p.images[0].src) || '',
            price: prices.length ? Math.min.apply(null, prices) : null,
            cfp: tags.some(function (t) { return t.toLowerCase() === 'call-for-price'; }),
            specs: {}
        };
        if (tab === 'wheels') {
            item.specs.pcd = extractPcd(p.title, tags);
            item.specs.size = extractWheelSize(p.title, tags);
            item.et = extractEt(p.title, tags);
        } else if (tab === 'tyres') {
            var t = extractTyre(p.title, tags);
            item.specs.width = t.width;
            item.specs.profile = t.profile;
            item.specs.rim = t.rim;
            item.specs.brand = extractTyreBrand(soup, p.vendor);
        } else {
            item.specs.make = extractTextMakes(soup);
            item.specs.type = extractSuspType(soup);
            item.specs.brand = extractSuspBrand(soup);
        }
        return item;
    }

    /* -------------------------------------------------------------------------
       DATA LOADING (cached per tab)
    -------------------------------------------------------------------------- */
    var store = { wheels: null, tyres: null, suspension: null };
    var loading = {};

    function cacheGet(tab) {
        try {
            var raw = sessionStorage.getItem('asf3:' + tab);
            if (!raw) return null;
            var obj = JSON.parse(raw);
            if (Date.now() - obj.t > CACHE_MINUTES * 60000) return null;
            return obj.items;
        } catch (e) { return null; }
    }
    function cacheSet(tab, items) {
        try { sessionStorage.setItem('asf3:' + tab, JSON.stringify({ t: Date.now(), items: items })); } catch (e) { }
    }
    function fetchCollection(handle) {
        var all = [];
        function page(n) {
            return fetch('/collections/' + handle + '/products.json?limit=250&page=' + n)
                .then(function (r) { if (!r.ok) throw new Error('not found'); return r.json(); })
                .then(function (data) {
                    var list = (data && data.products) || [];
                    all = all.concat(list);
                    if (list.length === 250 && n < 20) return page(n + 1);
                    return all;
                });
        }
        return page(1);
    }
    function loadTab(tab) {
        if (store[tab]) return Promise.resolve(store[tab]);
        var cached = cacheGet(tab);
        if (cached) { store[tab] = cached; return Promise.resolve(cached); }
        if (loading[tab]) return loading[tab];
        var handles = SOURCES[tab].slice();
        function tryNext() {
            if (!handles.length) return Promise.resolve([]);
            var h = handles.shift();
            return fetchCollection(h)
                .then(function (products) { return products.length ? products : tryNext(); })
                .catch(function () { return tryNext(); });
        }
        loading[tab] = tryNext().then(function (products) {
            var items = products.map(function (p) { return toItem(p, tab); });
            store[tab] = items;
            cacheSet(tab, items);
            delete loading[tab];
            return items;
        });
        return loading[tab];
    }

    /* -------------------------------------------------------------------------
       MATCHING
    -------------------------------------------------------------------------- */
    /* Which bolt patterns are allowed by the current wheel selection.
       ignorePcd = true when building the PCD dropdown itself. */
    function allowedPcds(sel, ignorePcd) {
        if (!ignorePcd && sel.pcd) return [sel.pcd];
        if (sel.make && sel.model) { var p = modelPcd(sel.make, sel.model); return p ? [p] : []; }
        if (sel.make) return makePcds(sel.make);
        return null; /* no restriction */
    }

    function wheelMatches(it, sel, skip) {
        if (skip !== 'size' && sel.size && (it.specs.size || []).indexOf(sel.size) === -1) return false;
        var allowed = allowedPcds(sel, skip === 'pcd');
        if (allowed && !intersects(it.specs.pcd || [], allowed)) return false;
        return true;
    }

    function genericMatches(it, sel, skip) {
        return Object.keys(sel).every(function (k) {
            if (k === skip || !sel[k]) return true;
            return (it.specs[k] || []).indexOf(sel[k]) !== -1;
        });
    }

    function matches(tab, it, sel, skip) {
        return tab === 'wheels' ? wheelMatches(it, sel, skip) : genericMatches(it, sel, skip);
    }

    function sortValues(key, values) {
        return values.sort(function (a, b) {
            if (key === 'pcd') {
                var pa = a.split('/'), pb = b.split('/');
                return (pa[0] - pb[0]) || (pa[1] - pb[1]);
            }
            var na = parseFloat(a), nb = parseFloat(b);
            if (!isNaN(na) && !isNaN(nb)) return na - nb;
            return a.localeCompare(b);
        });
    }

    /* Returns [{value, label, count}] for one dropdown */
    function optionsFor(tab, items, sel, key) {
        if (tab === 'wheels' && key === 'make') {
            return Object.keys(FITMENT).sort().map(function (mk) {
                var pcds = makePcds(mk);
                var n = items.filter(function (it) {
                    return (!sel.size || (it.specs.size || []).indexOf(sel.size) !== -1) && intersects(it.specs.pcd || [], pcds);
                }).length;
                return { value: mk, label: mk, count: n };
            });
        }
        if (tab === 'wheels' && key === 'model') {
            if (!sel.make) return [];
            return (FITMENT[sel.make] || []).map(function (m) {
                var n = items.filter(function (it) {
                    return (!sel.size || (it.specs.size || []).indexOf(sel.size) !== -1) && (it.specs.pcd || []).indexOf(m[1]) !== -1;
                }).length;
                return { value: m[0], label: m[0], count: n };
            });
        }
        var counts = {};
        items.forEach(function (it) {
            if (!matches(tab, it, sel, key)) return;
            var vals = it.specs[key] || [];
            if (tab === 'wheels' && key === 'pcd') {
                var allowed = allowedPcds(sel, true);
                if (allowed) vals = vals.filter(function (v) { return allowed.indexOf(v) !== -1; });
            }
            vals.forEach(function (v) { counts[v] = (counts[v] || 0) + 1; });
        });
        return sortValues(key, Object.keys(counts)).map(function (v) {
            return { value: v, label: (key === 'size' || key === 'rim') ? v + '″' : v, count: counts[v] };
        });
    }

    /* -------------------------------------------------------------------------
       UI STATE
    -------------------------------------------------------------------------- */
    var root = null;
    var activeTab = 'wheels';
    var selections = { wheels: {}, tyres: {}, suspension: {} };
    var shown = PAGE_SIZE;
    var lastResults = null;
    var openHelp = null;
    var guideOpen = false;

    var ICONS = {
        wheels: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/><line x1="12" y1="2" x2="12" y2="5"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="2" y1="12" x2="5" y2="12"/><line x1="19" y1="12" x2="22" y2="12"/></svg>',
        tyres: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="5"/></svg>',
        suspension: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>',
        search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>',
        chevron: '<svg class="asf-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"></polyline></svg>',
        check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>',
        wa: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.8 11.9 11.9 0 0 0 4.6 4c1.7.7 2.4.8 3.2.7.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.3-.2-.5-.3z"/></svg>'
    };

    /* -------------------------------------------------------------------------
       RENDER
    -------------------------------------------------------------------------- */
    function renderShell() {
        var T = TABS[activeTab];
        root.innerHTML =
            '<div class="asf-widget">' +
            '<div class="asf-tabs" role="tablist">' +
            Object.keys(TABS).map(function (tab) {
                return '<button type="button" role="tab" aria-selected="' + (tab === activeTab) + '" class="asf-tab' +
                    (tab === activeTab ? ' asf-tab--active' : '') + '" data-tab="' + tab + '">' + ICONS[tab] + TABS[tab].label + '</button>';
            }).join('') +
            '</div>' +
            '<div class="asf-head"><h3 class="asf-title">' + T.title + '</h3><p class="asf-sub">' + T.sub + '</p></div>' +
            '<div class="asf-fields" style="--asf-cols:' + T.fields.length + '">' +
            T.fields.map(function (f) {
                return '<div class="asf-field" data-field="' + f.key + '">' +
                    '<div class="asf-label-row">' +
                    '<span class="asf-step">' + f.step + '</span>' +
                    '<label class="asf-label" for="asf-' + f.key + '">' + esc(f.label) + '</label>' +
                    '<button type="button" class="asf-help-btn" data-help="' + f.key + '" aria-label="What is ' + esc(f.label) + '?">?</button>' +
                    '</div>' +
                    '<div class="asf-select-wrap">' +
                    '<select class="asf-select" id="asf-' + f.key + '" data-filter="' + f.key + '" disabled>' +
                    '<option value="">Loading…</option></select>' + ICONS.chevron +
                    '</div>' +
                    '<div class="asf-hint" id="asf-hint-' + f.key + '"></div>' +
                    '</div>';
            }).join('') +
            '</div>' +
            '<div class="asf-help" id="asf-help" hidden></div>' +
            (activeTab === 'wheels'
                ? '<div class="asf-guide" id="asf-guide"' + (guideOpen ? '' : ' hidden') + '>' + FITMENT_GUIDE + '</div>'
                : '') +
            '<div class="asf-footer">' +
            (activeTab === 'wheels'
                ? '<button type="button" class="asf-guide-btn" id="asf-guide-btn" aria-expanded="' + guideOpen + '">How wheel fitment works</button>'
                : '<span></span>') +
            '<div class="asf-actions">' +
            '<button type="button" class="asf-reset" id="asf-reset">Reset</button>' +
            '<button type="button" class="asf-submit" id="asf-submit-btn">Find ' + T.label + ' ' + ICONS.search + '</button>' +
            '</div></div>' +
            '</div>' +
            '<div class="asf-results" id="asf-results" aria-live="polite"></div>';

        bindEvents();
        if (openHelp) showHelp(openHelp);
        loadTab(activeTab).then(refreshOptions);
    }

    function refreshOptions() {
        var items = store[activeTab] || [];
        var sel = selections[activeTab];
        TABS[activeTab].fields.forEach(function (f) {
            var el = document.getElementById('asf-' + f.key);
            if (!el) return;
            var opts = optionsFor(activeTab, items, sel, f.key);

            if (sel[f.key] && !opts.some(function (o) { return o.value === sel[f.key]; })) delete sel[f.key];

            var placeholder = 'Any';
            if (activeTab === 'wheels' && f.key === 'make') placeholder = 'Choose your car';
            if (activeTab === 'wheels' && f.key === 'model') placeholder = sel.make ? 'Choose model' : 'Pick a make first';

            el.innerHTML = '<option value="">' + placeholder + '</option>' + opts.map(function (o) {
                var countLabel = o.count ? ' (' + o.count + ')' : ' (none in stock)';
                return '<option value="' + esc(o.value) + '"' + (sel[f.key] === o.value ? ' selected' : '') + '>' +
                    esc(o.label) + countLabel + '</option>';
            }).join('');
            el.disabled = !items.length || (activeTab === 'wheels' && f.key === 'model' && !sel.make);
        });
        updateHints();
    }

    function setHint(key, html, tone) {
        var el = document.getElementById('asf-hint-' + key);
        if (!el) return;
        el.innerHTML = html || '';
        el.className = 'asf-hint' + (tone ? ' asf-hint--' + tone : '');
    }

    function updateHints() {
        var sel = selections[activeTab];
        if (activeTab === 'wheels') {
            setHint('make', sel.make ? '' : 'Not listed? Skip to bolt pattern.');
            if (sel.make && sel.model) {
                setHint('model', ICONS.check + ' Uses <b>' + esc(modelPcd(sel.make, sel.model)) + '</b>', 'ok');
            } else if (sel.make) {
                setHint('model', esc(sel.make) + ' uses ' + makePcds(sel.make).map(esc).join(', '));
            } else {
                setHint('model', '');
            }
            if (sel.pcd && sel.model && modelPcd(sel.make, sel.model) === sel.pcd) {
                setHint('pcd', 'Set from your car', 'ok');
            } else {
                setHint('pcd', 'Bolts / circle size, e.g. 5/112');
            }
            setHint('size', sel.size ? '' : 'On your tyre: R17 = 17″');
        } else if (activeTab === 'tyres') {
            setHint('width', 'e.g. <b>225</b>/45 R17');
            setHint('profile', 'e.g. 225/<b>45</b> R17');
            setHint('rim', 'e.g. 225/45 <b>R17</b>');
            setHint('brand', '');
        } else {
            setHint('make', '');
            setHint('type', 'Tap ? to compare');
            setHint('brand', '');
        }
    }

    function showHelp(key) {
        var box = document.getElementById('asf-help');
        if (!box) return;
        var tabHelp = HELP[activeTab] || {};
        var h = tabHelp[key];
        if (h && h.ref) h = tabHelp[h.ref];
        if (!h) { box.hidden = true; openHelp = null; return; }
        openHelp = key;
        box.innerHTML =
            '<button type="button" class="asf-help-close" aria-label="Close">×</button>' +
            (h.svg ? '<div class="asf-help-fig">' + h.svg + '</div>' : '') +
            '<div class="asf-help-text"><h4>' + h.title + '</h4>' + h.body + '</div>';
        var field = root.querySelector('.asf-field[data-field="' + key + '"]');
        var grid = root.querySelector('.asf-fields');
        var narrow = window.matchMedia && window.matchMedia('(max-width: 640px)').matches;
        if (narrow && field) field.parentNode.insertBefore(box, field.nextSibling);
        else if (grid) grid.parentNode.insertBefore(box, grid.nextSibling);
        box.classList.toggle('asf-help--inline', !!(narrow && field));
        box.hidden = false;
        box.querySelector('.asf-help-close').addEventListener('click', function () {
            box.hidden = true; openHelp = null; markHelpButtons();
        });
        markHelpButtons();
    }

    function markHelpButtons() {
        root.querySelectorAll('.asf-help-btn').forEach(function (b) {
            var tabHelp = HELP[activeTab] || {};
            var k = b.getAttribute('data-help');
            var ref = tabHelp[k] && tabHelp[k].ref ? tabHelp[k].ref : k;
            var openRef = openHelp && tabHelp[openHelp] && tabHelp[openHelp].ref ? tabHelp[openHelp].ref : openHelp;
            b.classList.toggle('asf-help-btn--on', !!openHelp && ref === openRef);
        });
    }

    /* -------------------------------------------------------------------------
       RESULTS
    -------------------------------------------------------------------------- */
    function runSearch() {
        var items = store[activeTab] || [];
        var sel = selections[activeTab];
        lastResults = items.filter(function (it) { return matches(activeTab, it, sel); });
        shown = PAGE_SIZE;
        renderResults(true);
    }

    function carName(sel) {
        return sel.make ? (sel.make + (sel.model ? ' ' + sel.model : '')) : '';
    }

    function resultsHeading(sel, n) {
        var noun = TABS[activeTab].label.toLowerCase();
        if (n === 1) noun = noun.replace(/s$/, '');
        if (activeTab === 'wheels' && sel.make) {
            var pcds = allowedPcds(sel, false) || [];
            return n + ' ' + noun + ' that bolt onto your <b>' + esc(carName(sel)) + '</b>' +
                (pcds.length ? ' <span class="asf-muted">(' + pcds.map(esc).join(', ') + ')</span>' : '');
        }
        return n + ' ' + noun + ' found';
    }

    function fitmentNote(sel) {
        if (activeTab !== 'wheels') return '';
        var car = carName(sel);
        var msg = car
            ? 'Hi AutoStyling, I\'m looking at wheels for my ' + car + '. Please confirm fitment (offset & centre bore).'
            : 'Hi AutoStyling, please help me confirm which wheels fit my car.';
        return '<div class="asf-note">' +
            '<div class="asf-note-icon">' + ICONS.check + '</div>' +
            '<div class="asf-note-text"><b>Bolt pattern matched.</b> Before fitting we also check <b>offset (ET)</b> and <b>centre bore</b> for your exact car. ' +
            'Most wheels fit straight on or with spigot rings or spacers, which we supply. Shown ET is the wheel\'s offset, where listed.</div>' +
            '<a class="asf-note-btn" href="' + waLink(msg) + '" target="_blank" rel="noopener">' + ICONS.wa + 'Confirm fitment</a>' +
            '</div>';
    }

    function renderResults(scroll) {
        var box = document.getElementById('asf-results');
        if (!box || !lastResults) return;
        var sel = selections[activeTab];

        if (!lastResults.length) {
            var car = carName(sel);
            box.innerHTML =
                '<div class="asf-empty">' +
                '<h4>Nothing in stock for that combination right now</h4>' +
                '<p>Try another rim size, or let us source a set' + (car ? ' for your ' + esc(car) : '') + '. New stock lands every week.</p>' +
                '<a class="asf-note-btn" href="' + waLink('Hi AutoStyling, I\'m looking for ' + TABS[activeTab].label.toLowerCase() +
                    (car ? ' for my ' + car : '') + (sel.size ? ' in ' + sel.size + '"' : '') + '. Can you help?') +
                '" target="_blank" rel="noopener">' + ICONS.wa + 'Ask us on WhatsApp</a>' +
                '</div>';
        } else {
            var list = lastResults.slice(0, shown);
            box.innerHTML =
                '<div class="asf-results-head">' + resultsHeading(sel, lastResults.length) + '</div>' +
                fitmentNote(sel) +
                '<div class="asf-grid">' + list.map(function (it) { return card(it, sel); }).join('') + '</div>' +
                (lastResults.length > shown
                    ? '<div class="asf-more-wrap"><button type="button" class="asf-more" id="asf-more">Show more (' +
                      (lastResults.length - shown) + ' left)</button></div>'
                    : '');
            var more = document.getElementById('asf-more');
            if (more) more.addEventListener('click', function () { shown += PAGE_SIZE; renderResults(false); });
        }
        if (scroll) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function card(it, sel) {
        var img = it.img ? it.img + (it.img.indexOf('?') > -1 ? '&' : '?') + 'width=500' : '';
        var price = it.cfp ? '<span class="asf-card-cfp">Call for price</span>'
            : (it.price != null ? '<span class="asf-card-price">' + formatPrice(it.price) + '</span>' : '');
        var chips = '';
        if (activeTab === 'wheels') {
            var allowed = allowedPcds(sel, false);
            chips = (it.specs.size || []).map(function (s) { return '<span class="asf-tag">' + esc(s) + '″</span>'; }).join('') +
                (it.specs.pcd || []).map(function (p) {
                    var hit = allowed && allowed.indexOf(p) !== -1;
                    return '<span class="asf-tag' + (hit ? ' asf-tag--hit' : '') + '">' + esc(p) + '</span>';
                }).join('') +
                (it.et != null ? '<span class="asf-tag">ET' + esc(it.et) + '</span>' : '');
        }
        return '<a class="asf-card" href="/products/' + encodeURIComponent(it.handle) + '">' +
            '<div class="asf-card-img">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(it.title) + '" loading="lazy">' : '') + '</div>' +
            '<div class="asf-card-body">' +
            (chips ? '<div class="asf-tags">' + chips + '</div>' : '') +
            '<span class="asf-card-title">' + esc(it.title) + '</span>' + price +
            '</div></a>';
    }

    /* -------------------------------------------------------------------------
       EVENTS
    -------------------------------------------------------------------------- */
    function bindEvents() {
        root.querySelectorAll('.asf-tab').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var tab = btn.getAttribute('data-tab');
                if (tab === activeTab) return;
                activeTab = tab;
                lastResults = null;
                openHelp = null;
                renderShell();
            });
        });

        root.querySelectorAll('.asf-select').forEach(function (el) {
            el.addEventListener('change', function () {
                var key = el.getAttribute('data-filter');
                var sel = selections[activeTab];
                if (el.value) sel[key] = el.value; else delete sel[key];

                if (activeTab === 'wheels') {
                    if (key === 'make') { delete sel.model; delete sel.pcd; }
                    if (key === 'model') {
                        if (sel.model) sel.pcd = modelPcd(sel.make, sel.model);
                        else delete sel.pcd;
                    }
                    if (key === 'pcd' && sel.model && sel.pcd !== modelPcd(sel.make, sel.model)) delete sel.model;
                }
                refreshOptions();
            });
        });

        root.querySelectorAll('.asf-help-btn').forEach(function (b) {
            b.addEventListener('click', function () {
                var k = b.getAttribute('data-help');
                if (b.classList.contains('asf-help-btn--on')) {
                    document.getElementById('asf-help').hidden = true;
                    openHelp = null;
                    markHelpButtons();
                } else {
                    showHelp(k);
                }
            });
        });

        var guideBtn = document.getElementById('asf-guide-btn');
        if (guideBtn) guideBtn.addEventListener('click', function () {
            guideOpen = !guideOpen;
            document.getElementById('asf-guide').hidden = !guideOpen;
            guideBtn.setAttribute('aria-expanded', guideOpen);
        });

        document.getElementById('asf-submit-btn').addEventListener('click', function () {
            var btn = this;
            btn.disabled = true;
            loadTab(activeTab).then(function () { btn.disabled = false; runSearch(); });
        });

        document.getElementById('asf-reset').addEventListener('click', function () {
            selections[activeTab] = {};
            lastResults = null;
            document.getElementById('asf-results').innerHTML = '';
            refreshOptions();
        });
    }

    /* -------------------------------------------------------------------------
       STYLES
    -------------------------------------------------------------------------- */
    function injectStyles() {
        if (document.getElementById('as-finder-styles')) return;
        var style = document.createElement('style');
        style.id = 'as-finder-styles';
        style.textContent = [
            "@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');",
            "#as-finder-root{--asf-gold:#e8b84b;--asf-gold-ink:#9a7224;--asf-ink:#111;--asf-muted:#6b7280;--asf-line:rgba(0,0,0,.08);font-family:'Inter','Josefin Sans',system-ui,sans-serif;padding:32px 24px 40px;color:var(--asf-ink)}",
            ".asf-widget{max-width:1100px;margin:0 auto;background:rgba(255,255,255,.82);backdrop-filter:blur(20px) saturate(180%);-webkit-backdrop-filter:blur(20px) saturate(180%);border:1px solid rgba(255,255,255,.9);border-radius:20px;box-shadow:0 10px 40px rgba(0,0,0,.08),0 2px 8px rgba(0,0,0,.04);overflow:hidden}",
            ".asf-tabs{display:flex;background:rgba(246,246,246,.7);border-bottom:1px solid var(--asf-line);padding:6px 6px 0;gap:4px}",
            ".asf-tab{flex:1;display:flex;align-items:center;justify-content:center;gap:8px;padding:12px 16px;background:transparent;border:none;border-radius:12px 12px 0 0;color:#9ca3af;font-family:inherit;font-size:12px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;transition:all .2s ease}",
            ".asf-tab svg{width:16px;height:16px;flex-shrink:0}",
            ".asf-tab--active{background:#fff;color:var(--asf-ink);box-shadow:inset 0 3px 0 0 var(--asf-gold)}",
            ".asf-tab--active svg{stroke:var(--asf-gold)}",
            ".asf-tab:not(.asf-tab--active):hover{color:#374151}",
            ".asf-head{padding:22px 24px 4px}",
            ".asf-title{margin:0 0 4px;font-size:20px;font-weight:700;letter-spacing:-.01em;line-height:1.25;color:var(--asf-ink);text-transform:none}",
            ".asf-sub{margin:0;font-size:13px;line-height:1.5;color:var(--asf-muted)}",
            ".asf-sub b{color:var(--asf-ink)}",
            ".asf-fields{display:grid;grid-template-columns:repeat(var(--asf-cols,3),1fr);gap:12px;padding:16px 24px 8px}",
            ".asf-field{display:flex;flex-direction:column;gap:8px;padding:14px 14px 10px;border:1px solid var(--asf-line);border-radius:14px;background:#fff;transition:border-color .2s,box-shadow .2s}",
            ".asf-field:focus-within{border-color:var(--asf-gold);box-shadow:0 0 0 3px rgba(232,184,75,.18)}",
            ".asf-label-row{display:flex;align-items:center;gap:8px}",
            ".asf-step{width:18px;height:18px;border-radius:50%;background:var(--asf-ink);color:#fff;font-size:10px;font-weight:700;display:inline-flex;align-items:center;justify-content:center;flex-shrink:0}",
            ".asf-label{font-size:10px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:#4b5563;margin:0;flex:1}",
            ".asf-help-btn{width:20px;height:20px;border-radius:50%;border:1.5px solid #d1d5db;background:#fff;color:#6b7280;font-family:inherit;font-size:11px;font-weight:700;line-height:1;cursor:pointer;padding:0;display:inline-flex;align-items:center;justify-content:center;transition:all .15s}",
            ".asf-help-btn:hover,.asf-help-btn--on{border-color:var(--asf-gold);background:var(--asf-gold);color:var(--asf-ink)}",
            ".asf-select-wrap{position:relative}",
            ".asf-select{width:100%;appearance:none;-webkit-appearance:none;background:transparent;border:none;border-bottom:1.5px solid rgba(0,0,0,.12);color:var(--asf-ink);font-family:inherit;font-size:14px;font-weight:500;padding:6px 22px 7px 0;cursor:pointer;outline:none;transition:border-color .2s;text-overflow:ellipsis}",
            ".asf-select:disabled{color:#9ca3af;cursor:not-allowed}",
            ".asf-select:focus{border-bottom-color:var(--asf-gold)}",
            ".asf-select option{background:#fff;color:#111}",
            ".asf-chevron{position:absolute;right:0;top:50%;transform:translateY(-50%);width:14px;height:14px;color:#9ca3af;pointer-events:none}",
            ".asf-hint{min-height:16px;font-size:11px;line-height:1.4;color:#9ca3af}",
            ".asf-hint b{color:var(--asf-ink)}",
            ".asf-hint--ok{color:#15803d}",
            ".asf-hint--ok b{color:#15803d}",
            ".asf-hint svg{width:12px;height:12px;vertical-align:-2px;margin-right:3px}",
            ".asf-help{position:relative;display:flex;gap:20px;align-items:center;margin:8px 24px 4px;padding:18px 44px 18px 18px;background:#fbf7ee;border:1px solid #f0e2bf;border-radius:14px;animation:asfIn .2s ease}",
            ".asf-help[hidden],.asf-guide[hidden]{display:none}",
            ".asf-help-fig{flex-shrink:0;color:#374151}",
            ".asf-help--inline{margin:0 !important}",
            ".asf-diagram{width:110px;height:110px;display:block}",
            ".asf-diagram--wide{width:150px;height:66px}",
            ".asf-help-text h4{margin:0 0 6px;font-size:14px;font-weight:700;color:var(--asf-ink);text-transform:none;letter-spacing:0}",
            ".asf-help-text p{margin:0 0 6px;font-size:13px;line-height:1.55;color:#4b5563}",
            ".asf-help-text p:last-child{margin-bottom:0}",
            ".asf-help-text b{color:var(--asf-ink)}",
            ".asf-help-close{position:absolute;top:8px;right:10px;width:28px;height:28px;border:none;background:none;font-size:20px;line-height:1;color:#9ca3af;cursor:pointer}",
            ".asf-help-close:hover{color:var(--asf-ink)}",
            "@keyframes asfIn{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}",
            ".asf-guide{margin:8px 24px 4px;padding:16px 18px;border:1px solid var(--asf-line);border-radius:14px;background:#fafafa;animation:asfIn .2s ease}",
            ".asf-guide-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:18px}",
            ".asf-guide-grid b{display:block;font-size:12px;font-weight:700;margin-bottom:4px;color:var(--asf-ink)}",
            ".asf-guide-grid span{display:block;font-size:12px;line-height:1.5;color:var(--asf-muted)}",
            ".asf-footer{padding:12px 24px 20px;display:flex;align-items:center;justify-content:space-between;gap:16px}",
            ".asf-actions{display:flex;align-items:center;gap:14px}",
            ".asf-guide-btn{background:none;border:none;padding:6px 0;font-family:inherit;font-size:12px;font-weight:600;color:var(--asf-gold-ink);cursor:pointer;text-decoration:underline;text-underline-offset:3px}",
            ".asf-guide-btn:hover{color:var(--asf-ink)}",
            ".asf-reset{background:none;border:none;color:var(--asf-muted);font-family:inherit;font-size:12px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;padding:8px 4px}",
            ".asf-reset:hover{color:var(--asf-ink)}",
            ".asf-submit{display:inline-flex;align-items:center;gap:8px;padding:13px 30px;background:var(--asf-ink);color:#fff;border:none;border-radius:100px;font-family:inherit;font-size:12px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;cursor:pointer;transition:all .2s ease;box-shadow:0 4px 14px rgba(0,0,0,.15)}",
            ".asf-submit:hover{background:var(--asf-gold);color:#111 !important;box-shadow:0 6px 20px rgba(232,184,75,.35);transform:translateY(-1px)}",
            ".asf-submit:disabled{opacity:.6;cursor:wait;transform:none}",
            ".asf-submit svg{width:14px;height:14px}",
            ".asf-results{max-width:1100px;margin:0 auto;scroll-margin-top:90px}",
            ".asf-results:empty{display:none}",
            ".asf-results-head{margin:28px 0 12px;font-size:16px;color:var(--asf-ink)}",
            ".asf-muted{color:var(--asf-muted);font-weight:400}",
            ".asf-note{display:flex;align-items:center;gap:14px;padding:14px 16px;margin-bottom:18px;background:#f0fdf4;border:1px solid #bbf7d0;border-radius:14px}",
            ".asf-note-icon{width:28px;height:28px;border-radius:50%;background:#16a34a;color:#fff;display:flex;align-items:center;justify-content:center;flex-shrink:0}",
            ".asf-note-icon svg{width:15px;height:15px}",
            ".asf-note-text{flex:1;font-size:13px;line-height:1.5;color:#374151}",
            ".asf-note-text b{color:var(--asf-ink)}",
            ".asf-note-btn{display:inline-flex;align-items:center;gap:8px;padding:10px 18px;background:#25d366;color:#fff !important;border-radius:100px;font-size:12px;font-weight:700;letter-spacing:.04em;text-decoration:none;white-space:nowrap;flex-shrink:0}",
            ".asf-note-btn:hover{background:#1ebe5b}",
            ".asf-note-btn svg{width:16px;height:16px}",
            ".asf-empty{margin-top:24px;padding:24px;border:1px dashed #d1d5db;border-radius:16px;text-align:center}",
            ".asf-empty h4{margin:0 0 6px;font-size:16px;font-weight:700;text-transform:none;letter-spacing:0}",
            ".asf-empty p{margin:0 0 16px;font-size:13px;color:var(--asf-muted)}",
            ".asf-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:16px}",
            ".asf-card{display:flex;flex-direction:column;background:#fff;border:1px solid rgba(0,0,0,.06);border-radius:14px;overflow:hidden;text-decoration:none;color:var(--asf-ink);transition:box-shadow .2s,transform .2s}",
            ".asf-card:hover{box-shadow:0 8px 24px rgba(0,0,0,.08);transform:translateY(-2px)}",
            ".asf-card-img{aspect-ratio:1/1;background:#f7f7f7;display:flex;align-items:center;justify-content:center}",
            ".asf-card-img img{width:100%;height:100%;object-fit:contain}",
            ".asf-card-body{padding:12px 14px 14px;display:flex;flex-direction:column;gap:6px}",
            ".asf-tags{display:flex;flex-wrap:wrap;gap:4px}",
            ".asf-tag{font-size:10px;font-weight:600;padding:3px 7px;border-radius:6px;background:#f3f4f6;color:#4b5563}",
            ".asf-tag--hit{background:#111;color:#fff}",
            ".asf-card-title{font-size:13px;font-weight:500;line-height:1.35}",
            ".asf-card-price{font-size:14px;font-weight:700}",
            ".asf-card-cfp{font-size:12px;font-weight:700;color:var(--asf-gold-ink);text-transform:uppercase;letter-spacing:.05em}",
            ".asf-more-wrap{text-align:center;margin-top:20px}",
            ".asf-more{padding:11px 26px;background:#fff;color:#111;border:1.5px solid #111;border-radius:100px;font-family:inherit;font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;cursor:pointer}",
            ".asf-more:hover{background:#111;color:#fff}",
            "@media (max-width:980px){.asf-fields{grid-template-columns:1fr 1fr}.asf-grid{grid-template-columns:repeat(3,1fr)}.asf-guide-grid{grid-template-columns:1fr 1fr}}",
            "@media (max-width:640px){#as-finder-root{padding:16px 12px 28px}.asf-head{padding:18px 16px 2px}.asf-title{font-size:17px}.asf-fields{grid-template-columns:1fr;padding:14px 16px 6px;gap:10px}.asf-help,.asf-guide{margin:8px 16px 4px}.asf-help{flex-direction:column;align-items:flex-start;padding:16px 40px 16px 16px}.asf-tab{font-size:10px;gap:5px;padding:11px 6px}.asf-footer{flex-direction:column-reverse;align-items:stretch;padding:12px 16px 18px}.asf-actions{justify-content:space-between}.asf-submit{flex:1;justify-content:center}.asf-guide-btn{text-align:center}.asf-grid{grid-template-columns:repeat(2,1fr);gap:10px}.asf-guide-grid{grid-template-columns:1fr}.asf-note{flex-direction:column;align-items:flex-start}}"
        ].join('\n');
        document.head.appendChild(style);
    }

    /* -------------------------------------------------------------------------
       INIT
    -------------------------------------------------------------------------- */
    function init() {
        root = document.getElementById('as-finder-root');
        if (!root) return;
        injectStyles();
        renderShell();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();
/* =============================================================================
   AutoStyling Klerksdorp — Jetour T2 module
   1. Homepage feature  → <div id="as-jetour-teaser"></div>   (Build your T2)
   2. Jetour page       → <div id="as-jetour-root"></div>     (/pages/jetour)

   Products load from the smart collection "jetour-icaur-accessories" and are
   grouped by keywords in their titles, so new Jetour products slot in on
   their own as long as the title says what the part is.

   HOTSPOT POSITIONS: open any page with the feature and add ?hotspots=edit to
   the URL. Click on the photo and the x/y values are shown (and copied), ready
   to paste into VEHICLES below.
   ============================================================================= */
(function () {
    'use strict';

    /* -------------------------------------------------------------------------
       CONFIG
    -------------------------------------------------------------------------- */
    var COLLECTION = 'jetour-icaur-accessories';
    var PAGE_URL = '/pages/jetour';
    var WHATSAPP = '27797278886';

    /* Vehicles shown in the "Build your..." stage, with a toggle between them.
       image: paste the Shopify Files URL of the photo (Content → Files).
       ratio: the photo's width / height, so hotspots line up exactly.
       Hotspots: x / y are % from the top-left of the photo. Leave x/y out
       and the hotspot shows as a chip under the photo only.
       "match" = title keywords for the products that pop up. */
    var VEHICLES = [
        {
            id: 't2', name: 'Jetour T2', short: 'T2',
            image: 'https://cdn.shopify.com/s/files/1/0022/6485/8699/files/D23DB3B6-042C-4AD3-8D5D-FD8D0A8BCD09.webp?v=1793396923',
            ratio: '3 / 2',
            alt: 'Jetour T2 with roof rack, light bars, bonnet vents and off-road wheels',
            owns: function (t) { return !/icuar|icaur|\bv23\b/.test(t) || /jetour/.test(t); },
            hotspots: [
                { id: 'grille', label: 'Grilles & headlights', x: 41, y: 56, match: ['grill', 'headlight'] },
                { id: 'bumper', label: 'Bumpers & body kits', x: 42, y: 76, match: ['bumper', 'body kit', 'bodykit', 'city hunter'] },
                { id: 'nudge', label: 'Nudge bars', x: 16, y: 68, match: ['nudge bar'] },
                { id: 'bonnet', label: 'Bonnet vents', x: 31, y: 43, match: ['bonnet'] },
                { id: 'roof', label: 'Roof racks & light bars', x: 55, y: 23, match: ['roof rack', 'luggage platform', 'light bar', 'cross bar'] },
                { id: 'rear', label: 'Ladders & spare covers', x: 82, y: 36, match: ['ladder', 'spare wheel'] },
                { id: 'steps', label: 'Side steps, cladding & tool boxes', x: 73, y: 67, match: ['side step', 'steps', 'tool box', 'cladding'] },
                { id: 'wheels', label: 'Wheels', x: 61, y: 79, match: ['rims', 'pcd'] },
                { id: 'spoiler', label: 'Roof spoilers', match: ['spoiler', 'wing'] }
            ]
        },
        {
            id: 'v23', name: 'iCaur V23', short: 'V23',
            image: 'https://cdn.shopify.com/s/files/1/0022/6485/8699/files/ICAUR_2.jpg?v=1793396969',
            ratio: '4 / 3',
            alt: 'iCaur V23 kitted out by AutoStyling',
            owns: function (t) { return /icuar|icaur|\bv23\b/.test(t); },
            hotspots: [
                { id: 'v23-mask', label: 'Front mask', x: 27, y: 50, match: ['mask'] },
                { id: 'v23-kit', label: 'Neo armor body kit', x: 61, y: 45, match: ['body kit', 'armor'] },
                { id: 'v23-roof', label: 'Ladder, tool box & roof rack', x: 56, y: 15, match: ['ladder', 'toolbox', 'tool box', 'roof rack'] },
                { id: 'v23-spoiler', label: 'Roof spoiler', x: 87, y: 18, match: ['spoiler'] },
                { id: 'v23-wheels', label: 'Wheels', x: 62, y: 73, match: ['rims', 'pcd'] }
            ]
        }
    ];

    /* Page sections. Products are sorted into the FIRST section whose test matches;
       the order they appear on the page is set in groupSections(). */
    var SECTIONS = [
        { id: 'icaur', title: 'iCaur V23', sub: 'Body kits, styling and combos for the iCaur V23.', test: function (t) { return /icaur|icuar|\bv23\b/.test(t) && !isWheel(t); } },
        { id: 'wheels', title: 'Wheels', sub: '5x108 PCD rims made for the T2.', test: isWheel },
        { id: 'combos', title: 'Packs & combos', sub: 'Bundled upgrades at a better price.', test: function (t) { return /combo|starter pack|\bpack\b/.test(t); } },
        { id: 'bodykits', title: 'Body kits & bumpers', sub: 'Complete transformations and OEM-style bumpers.', test: function (t) { return /body ?kit|bumper|armor kit/.test(t); } },
        { id: 'lighting', title: 'Lighting & grilles', sub: 'LED grilles, headlights, tail lights and light bars.', test: function (t) { return /light|lamp|grill/.test(t); } },
        { id: 'roof', title: 'Roof, rear & styling', sub: 'Roof racks, ladders, spoilers, vents and spare wheel covers.', test: function (t) { return /roof|ladder|spoiler|wing|bonnet|vent|spare wheel/.test(t); } },
        { id: 'steps', title: 'Steps, bars & storage', sub: 'Side steps, nudge bars, tool boxes and mud flaps.', test: function (t) { return /step|nudge|tool ?box|mud ?flap|mask|spade/.test(t); } },
        { id: 'interior', title: 'Interior & protection', sub: 'Mats, protectors, covers and protection film.', test: function (t) { return /mat\b|mats|protect|cover|sill|console|kick|interior|film/.test(t); } },
        { id: 'more', title: 'More for your Jetour', sub: '', test: function () { return true; } }
    ];

    function isWheel(t) { return /\brims?\b|\bmags?\b|^\s*\d{2}\s*(”|"|''|″)/.test(t) && !/cover/.test(t); }

    /* -------------------------------------------------------------------------
       HELPERS
    -------------------------------------------------------------------------- */
    function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }
    function formatPrice(n) {
        return 'R ' + Number(n).toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    function waLink(text) {
        return 'https://wa.me/' + WHATSAPP + '?text=' + encodeURIComponent(text);
    }
    function imgUrl(src, w) {
        if (!src) return '';
        return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    /* Tidy shouty/duplicated titles for display: "JETOUR T2 2025+ LADDER" → "Jetour T2 2025+ Ladder" */
    function niceTitle(t) {
        var s = t.replace(/\s+/g, ' ').trim();
        if (s === s.toUpperCase()) {
            s = s.toLowerCase().replace(/\b([a-z])/g, function (m) { return m.toUpperCase(); })
                .replace(/\bT2\b/i, 'T2').replace(/\bLed\b/g, 'LED').replace(/\bOem\b/g, 'OEM').replace(/\bPcd\b/g, 'PCD');
        }
        return s;
    }

    /* -------------------------------------------------------------------------
       DATA
    -------------------------------------------------------------------------- */
    var dataPromise = null;
    function loadProducts() {
        if (dataPromise) return dataPromise;
        var cacheKey = 'asj1';
        try {
            var raw = sessionStorage.getItem(cacheKey);
            if (raw) {
                var c = JSON.parse(raw);
                if (Date.now() - c.t < 30 * 60000) return (dataPromise = Promise.resolve(c.items));
            }
        } catch (e) { }

        var all = [];
        function page(n) {
            return fetch('/collections/' + COLLECTION + '/products.json?limit=250&page=' + n)
                .then(function (r) { return r.ok ? r.json() : { products: [] }; })
                .then(function (d) {
                    var list = (d && d.products) || [];
                    all = all.concat(list);
                    return list.length === 250 && n < 5 ? page(n + 1) : all;
                });
        }
        dataPromise = page(1).then(function (products) {
            var items = products.map(function (p) {
                var tags = (Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',')).map(function (t) { return t.trim().toLowerCase(); });
                var vs = p.variants || [];
                var prices = vs.map(function (v) { return parseFloat(v.price); }).filter(function (n) { return !isNaN(n) && n > 0; });
                var compare = vs.map(function (v) { return parseFloat(v.compare_at_price); }).filter(function (n) { return !isNaN(n); });
                return {
                    title: niceTitle(p.title),
                    key: p.title.toLowerCase(),
                    handle: p.handle,
                    img: (p.images && p.images[0] && p.images[0].src) || '',
                    price: prices.length ? Math.min.apply(null, prices) : null,
                    compare: compare.length ? Math.max.apply(null, compare) : null,
                    available: vs.some(function (v) { return v.available; }),
                    cfp: tags.indexOf('call-for-price') !== -1,
                    created: p.created_at || ''
                };
            });
            /* In stock first, then newest */
            items.sort(function (a, b) {
                return (b.available - a.available) || (a.created < b.created ? 1 : -1);
            });
            try { sessionStorage.setItem(cacheKey, JSON.stringify({ t: Date.now(), items: items })); } catch (e) { }
            return items;
        });
        return dataPromise;
    }

    function itemsForHotspot(items, h) {
        return items.filter(function (it) {
            return h.match.some(function (m) { return it.key.indexOf(m) !== -1; });
        });
    }

    function groupSections(items) {
        var groups = {};
        items.forEach(function (it) {
            for (var i = 0; i < SECTIONS.length; i++) {
                if (SECTIONS[i].test(it.key)) { (groups[SECTIONS[i].id] = groups[SECTIONS[i].id] || []).push(it); break; }
            }
        });
        var order = ['combos', 'bodykits', 'lighting', 'roof', 'steps', 'wheels', 'interior', 'more', 'icaur'];
        return order.map(function (id) { return SECTIONS.filter(function (s) { return s.id === id; })[0]; })
            .filter(function (s) { return s && groups[s.id] && groups[s.id].length; })
            .map(function (s) { return { s: s, items: groups[s.id] }; });
    }

    /* -------------------------------------------------------------------------
       SHARED PIECES
    -------------------------------------------------------------------------- */
    var ICON_WA = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.8 11.9 11.9 0 0 0 4.6 4c1.7.7 2.4.8 3.2.7.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.3-.2-.5-.3z"/></svg>';
    var ICON_ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';

    function priceHtml(it) {
        if (it.cfp) return '<span class="asj-cfp">Call for price</span>';
        if (it.price == null) return '';
        return '<span class="asj-price">' + formatPrice(it.price) + '</span>' +
            (it.compare && it.compare > it.price ? '<s class="asj-was">' + formatPrice(it.compare) + '</s>' : '');
    }

    function productCard(it) {
        return '<a class="asj-card' + (it.available ? '' : ' asj-card--out') + '" href="/products/' + encodeURIComponent(it.handle) + '">' +
            '<div class="asj-card-img">' +
            (it.img ? '<img src="' + esc(imgUrl(it.img, 500)) + '" alt="' + esc(it.title) + '" loading="lazy">' : '') +
            (it.available ? '' : '<span class="asj-badge">Back soon</span>') +
            '</div>' +
            '<div class="asj-card-body"><span class="asj-card-title">' + esc(it.title) + '</span>' +
            '<div class="asj-card-price">' + priceHtml(it) + '</div></div>' +
            '</a>';
    }

    /* ---------------- Build-your-car hotspot stage (with T2 / V23 toggle) ---------------- */
    var openPops = [];
    document.addEventListener('click', function (e) {
        openPops.forEach(function (o) { if (!o.pop.hidden && !o.pop.contains(e.target)) o.close(); });
    });
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') openPops.forEach(function (o) { o.close(); });
    });

    function vehicleItems(items, v) {
        return items.filter(function (it) { return v.owns(it.key); });
    }

    /* Renders the stage into `slot` and keeps it in sync when the toggle is used.
       onSwitch(vehicle) lets the surrounding copy update (e.g. "Build your V23"). */
    function mountStage(slot, items, onSwitch) {
        var current = VEHICLES[0];
        var editMode = /[?&]hotspots=edit/.test(location.search);

        function render() {
            var v = current;
            var placed = v.hotspots.filter(function (h) { return h.x != null && h.y != null; });
            slot.innerHTML =
                '<div class="asj-stage">' +
                (VEHICLES.length > 1
                    ? '<div class="asj-switch" role="tablist" aria-label="Choose your vehicle">' +
                      VEHICLES.map(function (x) {
                          return '<button type="button" role="tab" aria-selected="' + (x === v) + '" class="asj-switch-btn' + (x === v ? ' is-on' : '') + '" data-vehicle="' + x.id + '">' + esc(x.name) + '</button>';
                      }).join('') + '</div>'
                    : '') +
                '<div class="asj-stage-media' + (v.image ? '' : ' asj-stage-media--empty') + (editMode ? ' asj-edit' : '') + '" style="aspect-ratio:' + v.ratio + '">' +
                (v.image
                    ? '<img class="asj-stage-img" src="' + esc(imgUrl(v.image, 1800)) + '" alt="' + esc(v.alt) + '">'
                    : '<div class="asj-stage-placeholder"><span>' + esc(v.name.toUpperCase()) + '</span></div>') +
                placed.map(function (h, i) {
                    return '<button type="button" class="asj-dot" data-hotspot="' + h.id + '" style="left:' + h.x + '%;top:' + h.y + '%;--d:' + (i * 0.25) + 's" aria-label="' + esc(h.label) + '">' +
                        '<span class="asj-dot-core">+</span><span class="asj-dot-label">' + esc(h.label) + '</span></button>';
                }).join('') +
                (editMode ? '<div class="asj-edit-tip">Edit mode: click the photo to get x / y</div>' : '') +
                '<div class="asj-pop" hidden></div>' +
                '</div>' +
                '<div class="asj-chips">' +
                v.hotspots.map(function (h) {
                    return '<button type="button" class="asj-chip" data-hotspot="' + h.id + '">' + esc(h.label) + '</button>';
                }).join('') +
                '</div></div>';
            bind();
        }

        function bind() {
            var v = current;
            var media = slot.querySelector('.asj-stage-media');
            var pop = slot.querySelector('.asj-pop');
            var own = vehicleItems(items, v);

            function close() {
                pop.hidden = true;
                slot.querySelectorAll('.asj-dot, .asj-chip').forEach(function (d) { d.classList.remove('is-on'); });
            }
            openPops = openPops.filter(function (o) { return o.slot !== slot; });
            openPops.push({ slot: slot, pop: pop, close: close });

            function open(id) {
                var h = v.hotspots.filter(function (x) { return x.id === id; })[0];
                if (!h) return;
                var list = itemsForHotspot(own, h);
                var inStock = list.filter(function (x) { return x.available; });
                var show = (inStock.length ? inStock : list).slice(0, 3);

                slot.querySelectorAll('.asj-dot, .asj-chip').forEach(function (d) {
                    d.classList.toggle('is-on', d.getAttribute('data-hotspot') === id);
                });

                pop.innerHTML =
                    '<div class="asj-pop-head"><b>' + esc(h.label) + '</b>' +
                    '<span>' + (list.length ? inStock.length + ' in stock' + (list.length > inStock.length ? ' · ' + (list.length - inStock.length) + ' coming' : '') : 'Ask us') + '</span>' +
                    '<button type="button" class="asj-pop-x" aria-label="Close">×</button></div>' +
                    (show.length
                        ? show.map(function (it) {
                            return '<a class="asj-pop-item" href="/products/' + encodeURIComponent(it.handle) + '">' +
                                '<span class="asj-pop-img">' + (it.img ? '<img src="' + esc(imgUrl(it.img, 160)) + '" alt="" loading="lazy">' : '') + '</span>' +
                                '<span class="asj-pop-txt"><span class="asj-pop-title">' + esc(it.title) + '</span>' + priceHtml(it) +
                                (it.available ? '' : '<span class="asj-pop-out">Back soon</span>') + '</span></a>';
                        }).join('')
                        : '<p class="asj-pop-empty">We can source this for your ' + esc(v.name) + '.</p>') +
                    '<div class="asj-pop-foot">' +
                    (list.length
                        ? '<a href="' + PAGE_URL + '#asj-' + sectionIdFor(list[0]) + '">See all ' + ICON_ARROW + '</a>'
                        : '<a href="' + waLink('Hi AutoStyling, I\'m looking for ' + h.label.toLowerCase() + ' for my ' + v.name + '.') + '" target="_blank" rel="noopener">' + ICON_WA + ' Ask on WhatsApp</a>') +
                    '</div>';

                /* Desktop: beside the dot (or centred for chip-only hotspots). Phones: below the photo. */
                var narrow = window.matchMedia('(max-width: 700px)').matches;
                pop.classList.toggle('asj-pop--dock', narrow);
                if (narrow) media.parentNode.insertBefore(pop, media.nextSibling);
                else if (pop.parentNode !== media) media.appendChild(pop);
                if (!narrow) {
                    var x = h.x != null ? h.x : 50, y = h.y != null ? h.y : 40;
                    pop.style.left = (x > 55 ? 'auto' : 'calc(' + x + '% + 26px)');
                    pop.style.right = (x > 55 ? 'calc(' + (100 - x) + '% + 26px)' : 'auto');
                    pop.style.top = 'clamp(12px, calc(' + y + '% - 70px), calc(100% - 330px))';
                } else {
                    pop.style.left = pop.style.right = pop.style.top = '';
                }
                pop.hidden = false;
                pop.querySelector('.asj-pop-x').addEventListener('click', close);
            }

            slot.querySelectorAll('.asj-dot, .asj-chip').forEach(function (b) {
                b.addEventListener('click', function (e) {
                    e.stopPropagation();
                    if (b.classList.contains('is-on') && !pop.hidden) close();
                    else open(b.getAttribute('data-hotspot'));
                });
            });

            slot.querySelectorAll('.asj-switch-btn').forEach(function (b) {
                b.addEventListener('click', function (e) {
                    e.stopPropagation();
                    var next = VEHICLES.filter(function (x) { return x.id === b.getAttribute('data-vehicle'); })[0];
                    if (!next || next === current) return;
                    current = next;
                    render();
                    if (onSwitch) onSwitch(current);
                });
            });

            /* Hotspot positioning helper: add ?hotspots=edit to the URL */
            if (editMode) {
                var tip = media.querySelector('.asj-edit-tip');
                media.addEventListener('click', function (e) {
                    if (e.target.closest('.asj-dot, .asj-pop')) return;
                    var r = media.getBoundingClientRect();
                    var txt = 'x: ' + ((e.clientX - r.left) / r.width * 100).toFixed(1) + ', y: ' + ((e.clientY - r.top) / r.height * 100).toFixed(1);
                    tip.textContent = v.short + ' → ' + txt + '  (copied)';
                    try { navigator.clipboard.writeText(txt); } catch (err) { }
                });
            }
        }

        render();
        if (onSwitch) onSwitch(current);
    }

    function sectionIdFor(it) {
        if (!it) return 'all';
        for (var i = 0; i < SECTIONS.length; i++) if (SECTIONS[i].test(it.key)) return SECTIONS[i].id;
        return 'all';
    }

    /* -------------------------------------------------------------------------
       1. HOMEPAGE FEATURE
    -------------------------------------------------------------------------- */
    function initTeaser(root, items) {
        var inStock = items.filter(function (x) { return x.available; }).length;
        root.innerHTML =
            '<section class="asj asj-teaser">' +
            '<div class="asj-teaser-copy">' +
            '<span class="asj-eyebrow"><i></i>Jetour T2 &amp; iCaur V23</span>' +
            '<h2 class="asj-h2">Build your <em class="asj-vname">T2</em></h2>' +
            '<p class="asj-lead">Tap the glowing points to kit out your <span class="asj-vfull">Jetour T2</span>. Body kits, LED grilles, roof racks, side steps and wheels' +
            (inStock ? ', with <b>' + inStock + ' parts in stock</b> now.' : '.') + '</p>' +
            '<div class="asj-ctas">' +
            '<a class="asj-btn asj-btn--gold" href="' + PAGE_URL + '">Shop all Jetour ' + ICON_ARROW + '</a>' +
            '<a class="asj-btn asj-btn--ghost" href="' + waLink('Hi AutoStyling, I\'d like to kit out my Jetour T2. Can you help?') + '" target="_blank" rel="noopener">' + ICON_WA + ' Chat to us</a>' +
            '</div></div>' +
            '<div class="asj-stage-slot"></div>' +
            '</section>';
        mountStage(root.querySelector('.asj-stage-slot'), items, function (v) {
            root.querySelector('.asj-vname').textContent = v.short;
            root.querySelector('.asj-vfull').textContent = v.name;
        });
    }

    /* -------------------------------------------------------------------------
       2. JETOUR PAGE
    -------------------------------------------------------------------------- */
    function initPage(root, items) {
        var groups = groupSections(items);
        var inStock = items.filter(function (x) { return x.available; }).length;

        root.innerHTML =
            '<div class="asj asj-page">' +
            '<section class="asj-hero">' +
            '<div class="asj-hero-copy">' +
            '<span class="asj-eyebrow"><i></i>The Jetour shop</span>' +
            '<h1 class="asj-h1">Everything for your <em class="asj-vfull">Jetour T2</em></h1>' +
            '<p class="asj-lead">From full Defender-style transformations to the small finishing touches. Tap the car to explore by area, or browse every category below.</p>' +
            '<ul class="asj-facts">' +
            '<li><b>' + items.length + '</b> T2 &amp; V23 parts</li>' +
            '<li><b>' + inStock + '</b> in stock now</li>' +
            '<li>Pay later with <b>Payflex</b>, <b>PayJustNow</b> &amp; <b>Mobicred</b></li>' +
            '</ul></div>' +
            '<div class="asj-stage-slot"></div>' +
            '</section>' +
            '<nav class="asj-nav" aria-label="Jetour categories"><div class="asj-nav-inner">' +
            groups.map(function (g) {
                return '<a class="asj-nav-link" href="#asj-' + g.s.id + '">' + esc(g.s.title) + '<span>' + g.items.length + '</span></a>';
            }).join('') +
            '</div></nav>' +
            groups.map(function (g) {
                return '<section class="asj-section' + (g.s.id === 'icaur' ? ' asj-section--icaur' : '') + '" id="asj-' + g.s.id + '">' +
                    '<div class="asj-section-head"><h2 class="asj-h3">' + esc(g.s.title) + '</h2>' +
                    (g.s.sub ? '<p>' + esc(g.s.sub) + '</p>' : '') + '</div>' +
                    '<div class="asj-grid">' + g.items.map(productCard).join('') + '</div>' +
                    '</section>';
            }).join('') +
            '<section class="asj-cta">' +
            '<div><h2 class="asj-h3">Can\'t see the part you need?</h2>' +
            '<p>New Jetour stock lands all the time. Send us a photo of what you\'re after and we\'ll source it.</p></div>' +
            '<a class="asj-btn asj-btn--gold" href="' + waLink('Hi AutoStyling, I\'m looking for a part for my Jetour T2:') + '" target="_blank" rel="noopener">' + ICON_WA + ' WhatsApp us</a>' +
            '</section>' +
            '</div>';

        mountStage(root.querySelector('.asj-stage-slot'), items, function (v) {
            root.querySelector('.asj-vfull').textContent = v.name;
        });
        bindNav(root);
        if (location.hash) {
            var t = document.querySelector(location.hash);
            if (t) setTimeout(function () { t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 100);
        }
    }

    function bindNav(root) {
        var links = [].slice.call(root.querySelectorAll('.asj-nav-link'));
        if (!('IntersectionObserver' in window) || !links.length) return;
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
                if (!en.isIntersecting) return;
                links.forEach(function (l) { l.classList.toggle('is-on', l.getAttribute('href') === '#' + en.target.id); });
                var on = root.querySelector('.asj-nav-link.is-on');
                if (on && on.scrollIntoView) on.parentNode.scrollTo({ left: on.offsetLeft - 16, behavior: 'smooth' });
            });
        }, { rootMargin: '-40% 0px -55% 0px' });
        root.querySelectorAll('.asj-section').forEach(function (s) { io.observe(s); });
    }

    /* -------------------------------------------------------------------------
       STYLES  (black + gold, matches the AS banners)
    -------------------------------------------------------------------------- */
    function injectStyles() {
        if (document.getElementById('as-jetour-styles')) return;
        var st = document.createElement('style');
        st.id = 'as-jetour-styles';
        st.textContent = [
            "@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');",
            ".asj{--g:#e8b84b;--g2:#c9952e;--ink:#0b0b0c;--panel:#141416;--line:rgba(255,255,255,.08);--txt:#f4f4f2;--mut:#a1a1a6;font-family:'Inter',system-ui,sans-serif;color:var(--txt);-webkit-font-smoothing:antialiased}",
            ".asj *{box-sizing:border-box}",
            ".asj em{font-style:normal;background:linear-gradient(90deg,#f6d27a,var(--g),#c9952e);-webkit-background-clip:text;background-clip:text;color:transparent}",
            ".asj-eyebrow{display:inline-flex;align-items:center;gap:8px;font-size:11px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:var(--g)}",
            ".asj-eyebrow i{width:7px;height:7px;border-radius:50%;background:var(--g);box-shadow:0 0 0 0 rgba(232,184,75,.6);animation:asjPulse 2s infinite}",
            ".asj-h1,.asj-h2{margin:12px 0 12px;font-weight:800;letter-spacing:-.02em;line-height:1.05;color:var(--txt);text-transform:none}",
            ".asj-h1{font-size:clamp(32px,4.4vw,56px)}",
            ".asj-h2{font-size:clamp(30px,4vw,52px)}",
            ".asj-h3{margin:0;font-size:clamp(20px,2.2vw,26px);font-weight:700;letter-spacing:-.01em;color:inherit;text-transform:none}",
            ".asj-lead{margin:0 0 22px;font-size:15px;line-height:1.6;color:var(--mut);max-width:440px}",
            ".asj-lead b{color:var(--txt)}",
            ".asj-ctas{display:flex;flex-wrap:wrap;gap:10px}",
            ".asj-btn{display:inline-flex;align-items:center;gap:8px;padding:13px 22px;border-radius:100px;font-size:12px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;text-decoration:none;transition:transform .2s,box-shadow .2s,background .2s}",
            ".asj-btn svg{width:15px;height:15px}",
            ".asj-btn--gold{background:linear-gradient(135deg,#f6d27a,var(--g) 45%,var(--g2));color:#111 !important;box-shadow:0 8px 24px rgba(232,184,75,.25)}",
            ".asj-btn--gold:hover{transform:translateY(-2px);box-shadow:0 12px 30px rgba(232,184,75,.35)}",
            ".asj-btn--ghost{border:1px solid rgba(255,255,255,.18);color:var(--txt) !important}",
            ".asj-btn--ghost:hover{border-color:var(--g);color:var(--g) !important}",

            /* stage */
            ".asj-stage{min-width:0}",
            ".asj-switch{display:inline-flex;gap:4px;padding:4px;margin-bottom:12px;border-radius:100px;background:rgba(255,255,255,.05);border:1px solid var(--line)}",
            ".asj-switch-btn{padding:8px 16px;border:none;border-radius:100px;background:none;color:var(--mut);font-family:inherit;font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;transition:all .2s}",
            ".asj-switch-btn:hover{color:var(--txt)}",
            ".asj-switch-btn.is-on{background:var(--g);color:#111}",
            ".asj-stage-media{position:relative;border-radius:18px;overflow:visible;background:radial-gradient(120% 90% at 50% 100%,#2a2416 0%,#121214 55%,#0b0b0c 100%);aspect-ratio:3/2;border:1px solid var(--line);box-shadow:0 30px 80px rgba(0,0,0,.5)}",
            ".asj-stage-img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:18px}",
            ".asj-stage-placeholder{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;border-radius:18px;overflow:hidden}",
            ".asj-stage-placeholder span{font-size:clamp(40px,8vw,110px);font-weight:800;letter-spacing:.12em;color:rgba(255,255,255,.05)}",
            ".asj-dot{position:absolute;transform:translate(-50%,-50%);width:30px;height:30px;padding:0;border:none;background:none;cursor:pointer;z-index:2}",
            ".asj-dot::before{content:'';position:absolute;inset:-6px;border-radius:50%;border:2px solid rgba(232,184,75,.55);animation:asjRing 2.4s ease-out infinite;animation-delay:var(--d)}",
            ".asj-dot-core{position:relative;display:flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:50%;background:var(--g);color:#111;font-size:18px;font-weight:700;line-height:1;box-shadow:0 0 0 4px rgba(11,11,12,.55),0 0 22px rgba(232,184,75,.7);transition:transform .2s}",
            ".asj-dot:hover .asj-dot-core,.asj-dot.is-on .asj-dot-core{transform:scale(1.15) rotate(45deg)}",
            ".asj-dot-label{position:absolute;left:50%;bottom:calc(100% + 10px);transform:translateX(-50%) translateY(4px);white-space:nowrap;padding:5px 10px;border-radius:8px;background:rgba(11,11,12,.9);color:var(--txt);font-size:11px;font-weight:600;opacity:0;pointer-events:none;transition:all .18s}",
            ".asj-dot:hover .asj-dot-label{opacity:1;transform:translateX(-50%)}",
            ".asj-dot.is-on .asj-dot-label{display:none}",
            ".asj-pop{position:absolute;z-index:5;width:300px;max-width:calc(100% - 24px);background:rgba(20,20,22,.97);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);border:1px solid rgba(232,184,75,.35);border-radius:16px;box-shadow:0 24px 60px rgba(0,0,0,.55);padding:14px;animation:asjIn .18s ease}",
            ".asj-pop[hidden]{display:none}",
            ".asj-pop--dock{position:relative;left:auto !important;right:auto !important;top:auto !important;width:auto;max-width:none;margin-top:12px}",
            ".asj-pop-head{display:flex;align-items:baseline;gap:8px;margin-bottom:10px;padding-right:22px;position:relative}",
            ".asj-pop-head b{font-size:14px;color:var(--txt)}",
            ".asj-pop-head span{font-size:11px;color:var(--g)}",
            ".asj-pop-x{position:absolute;right:-4px;top:-6px;width:28px;height:28px;border:none;background:none;color:var(--mut);font-size:20px;cursor:pointer}",
            ".asj-pop-item{display:flex;gap:10px;align-items:center;padding:8px;margin:0 -8px;border-radius:10px;text-decoration:none;color:var(--txt);transition:background .15s}",
            ".asj-pop-item:hover{background:rgba(255,255,255,.06)}",
            ".asj-pop-img{width:54px;height:54px;flex-shrink:0;border-radius:8px;background:#fff;overflow:hidden;display:flex;align-items:center;justify-content:center}",
            ".asj-pop-img img{width:100%;height:100%;object-fit:contain}",
            ".asj-pop-txt{display:flex;flex-direction:column;gap:3px;min-width:0}",
            ".asj-pop-title{font-size:12.5px;font-weight:500;line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}",
            ".asj-pop-out{font-size:10px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:var(--mut)}",
            ".asj-pop-empty{margin:4px 0 8px;font-size:13px;color:var(--mut)}",
            ".asj-pop-foot{margin-top:8px;padding-top:10px;border-top:1px solid var(--line)}",
            ".asj-pop-foot a{display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:700;color:var(--g);text-decoration:none;letter-spacing:.02em}",
            ".asj-pop-foot svg{width:14px;height:14px}",
            ".asj-price{font-size:13px;font-weight:700;color:var(--txt)}",
            ".asj-was{margin-left:6px;font-size:11px;color:var(--mut)}",
            ".asj-cfp{font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:var(--g)}",
            ".asj-chips{display:flex;flex-wrap:wrap;gap:8px;margin-top:14px}",
            ".asj-chip{padding:8px 13px;border-radius:100px;border:1px solid var(--line);background:rgba(255,255,255,.03);color:var(--mut);font-family:inherit;font-size:12px;font-weight:600;cursor:pointer;transition:all .15s}",
            ".asj-chip:hover,.asj-chip.is-on{border-color:var(--g);color:var(--g)}",
            ".asj-edit{cursor:crosshair}",
            ".asj-edit-tip{position:absolute;left:12px;top:12px;z-index:6;padding:6px 10px;border-radius:8px;background:#e8b84b;color:#111;font-size:12px;font-weight:700}",

            /* teaser */
            ".asj-teaser{display:grid;grid-template-columns:minmax(260px,.8fr) 1.6fr;gap:40px;align-items:center;max-width:1240px;margin:0 auto;padding:56px 40px;background:radial-gradient(80% 120% at 0% 0%,#1d1a12 0%,var(--ink) 55%);border-radius:24px;border:1px solid var(--line)}",
            "#as-jetour-teaser{padding:24px}",

            /* page */
            ".asj-page{background:var(--ink);border-radius:0;padding-bottom:56px}",
            ".asj-hero{display:grid;grid-template-columns:minmax(280px,.85fr) 1.5fr;gap:44px;align-items:center;max-width:1280px;margin:0 auto;padding:56px 32px 40px}",
            ".asj-facts{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:8px}",
            ".asj-facts li{font-size:13px;color:var(--mut);padding-left:18px;position:relative}",
            ".asj-facts li::before{content:'';position:absolute;left:0;top:7px;width:8px;height:2px;background:var(--g)}",
            ".asj-facts b{color:var(--txt)}",
            ".asj-nav{position:sticky;top:0;z-index:20;background:rgba(11,11,12,.92);backdrop-filter:blur(12px);-webkit-backdrop-filter:blur(12px);border-top:1px solid var(--line);border-bottom:1px solid var(--line)}",
            ".asj-nav-inner{display:flex;gap:6px;max-width:1280px;margin:0 auto;padding:10px 32px;overflow-x:auto;scrollbar-width:none}",
            ".asj-nav-inner::-webkit-scrollbar{display:none}",
            ".asj-nav-link{flex-shrink:0;display:inline-flex;align-items:center;gap:8px;padding:9px 14px;border-radius:100px;color:var(--mut);font-size:13px;font-weight:600;text-decoration:none;transition:all .15s}",
            ".asj-nav-link span{font-size:10px;padding:2px 7px;border-radius:100px;background:rgba(255,255,255,.08)}",
            ".asj-nav-link:hover{color:var(--txt)}",
            ".asj-nav-link.is-on{background:var(--g);color:#111}",
            ".asj-nav-link.is-on span{background:rgba(0,0,0,.15)}",
            ".asj-section{max-width:1280px;margin:0 auto;padding:44px 32px 8px;scroll-margin-top:70px}",
            ".asj-section-head{display:flex;flex-wrap:wrap;align-items:baseline;gap:6px 16px;margin-bottom:18px}",
            ".asj-section-head p{margin:0;font-size:13px;color:var(--mut)}",
            ".asj-section--icaur{margin-top:32px;padding-top:48px;border-top:1px solid var(--line)}",
            ".asj-section--icaur .asj-h3::after{content:'Also in stock';margin-left:10px;vertical-align:middle;font-size:10px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;padding:3px 8px;border-radius:6px;background:rgba(232,184,75,.15);color:var(--g)}",
            ".asj-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:16px}",
            ".asj-card{display:flex;flex-direction:column;background:var(--panel);border:1px solid var(--line);border-radius:16px;overflow:hidden;text-decoration:none;color:var(--txt);transition:transform .2s,border-color .2s,box-shadow .2s}",
            ".asj-card:hover{transform:translateY(-3px);border-color:rgba(232,184,75,.45);box-shadow:0 14px 40px rgba(0,0,0,.4)}",
            ".asj-card-img{position:relative;aspect-ratio:1/1;background:#fff;display:flex;align-items:center;justify-content:center}",
            ".asj-card-img img{width:100%;height:100%;object-fit:contain}",
            ".asj-card--out .asj-card-img img{opacity:.55;filter:grayscale(.4)}",
            ".asj-badge{position:absolute;left:10px;top:10px;padding:4px 9px;border-radius:6px;background:#111;color:var(--txt);font-size:10px;font-weight:700;letter-spacing:.08em;text-transform:uppercase}",
            ".asj-card-body{display:flex;flex-direction:column;gap:8px;padding:14px 14px 16px;flex:1}",
            ".asj-card-title{font-size:13.5px;font-weight:500;line-height:1.35}",
            ".asj-card-price{margin-top:auto}",
            ".asj-cta{display:flex;align-items:center;justify-content:space-between;gap:24px;max-width:1216px;margin:48px auto 0;padding:28px 32px;border-radius:20px;background:linear-gradient(120deg,#1d1a12,#141416);border:1px solid rgba(232,184,75,.25)}",
            ".asj-cta p{margin:6px 0 0;font-size:14px;color:var(--mut)}",

            "@keyframes asjRing{0%{transform:scale(.7);opacity:.9}80%,100%{transform:scale(1.6);opacity:0}}",
            "@keyframes asjPulse{0%{box-shadow:0 0 0 0 rgba(232,184,75,.6)}70%{box-shadow:0 0 0 8px rgba(232,184,75,0)}100%{box-shadow:0 0 0 0 rgba(232,184,75,0)}}",
            "@keyframes asjIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}",
            "@media (prefers-reduced-motion:reduce){.asj-dot::before,.asj-eyebrow i{animation:none}}",

            "@media (max-width:1024px){.asj-grid{grid-template-columns:repeat(3,1fr)}.asj-teaser,.asj-hero{grid-template-columns:1fr;gap:28px}.asj-lead{max-width:none}}",
            "@media (max-width:700px){#as-jetour-teaser{padding:12px}.asj-teaser{padding:32px 18px;border-radius:20px}.asj-hero{padding:32px 16px 24px}.asj-section{padding:36px 16px 4px}.asj-nav-inner{padding:10px 16px}.asj-grid{grid-template-columns:repeat(2,1fr);gap:10px}.asj-card-body{padding:10px 10px 12px}.asj-card-title{font-size:12.5px}.asj-dot,.asj-dot-core{width:26px;height:26px}.asj-dot-core{font-size:16px}.asj-dot-label{display:none}.asj-cta{flex-direction:column;align-items:flex-start;margin:36px 16px 0;padding:22px}.asj-stage-media{overflow:hidden}}"
        ].join('\n');
        document.head.appendChild(st);
    }

    /* -------------------------------------------------------------------------
       INIT
    -------------------------------------------------------------------------- */
    function init() {
        var teaser = document.getElementById('as-jetour-teaser');
        var page = document.getElementById('as-jetour-root');
        if (!teaser && !page) return;
        injectStyles();
        loadProducts().then(function (items) {
            if (teaser) initTeaser(teaser, items);
            if (page) initPage(page, items);
        });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();